<template>
<template  v-if="eventDetails.eventName != null">
    <section class="league-name-sec" loading="lazy">
        <div class="favourate-game live-matches-title">
            <div class="fav-left">
                <a href="javascript:void(0);" @click="$router.back()">
                    <span class="angle-left-box"><i class="fa-solid fa-angle-left"></i></span>
                </a>
                <span>{{capitalizeV(eventDetails.eventName) }}</span>
            </div>
            <div class="fav-rgt-star live-tv-wrapper">
                <template v-if="$auth.status">
                    <label for="image-check" class="star-fav">
                        <input type="checkbox" id="image-check" />
                        <div class="fav_lodder" v-if="loadingFav">
                            <i class="fa-solid fa-spinner fa-spin fa-2x"></i>
                        </div>
                        <i v-else-if="eventDetails?.favourite" @click="makeFavourite(eventDetails)" data-bs-toggle="tooltip" data-bs-placement="bottom" 
                        title="Remove from Favorite"><img src="@/assets/images/star_fill_icon.svg"></i>
                        <i v-else @click="makeFavourite(eventDetails)" data-bs-toggle="tooltip"
                            data-bs-placement="bottom" title="Add to Favorite"><img src="@/assets/images/star_icon.svg"></i>
                    </label>
                </template>
                <button type="button" class="watch-live-tv-btn" @click="showTv()" v-if="!eventDetails?.is_exclusive">
                    <div v-if="showLiveTv">
                        <span class="watch-tv">
                            <i class="fa-solid fa-xmark"></i>
                        </span>
                        <span>{{ $t('hide','Hide')}}</span>
                    </div>
                    <div v-else>
                        <span class="watch-tv">
                            <i class="fa-solid fa-play"></i>
                        </span>
                        <span>{{ $t('watch','Watch')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </section>

    <section :class="!eventDetails?.is_exclusive ? 'details-inplay-game-sec' : ''" loading="lazy">
        <div class="remove-padding">
            <div class="row g-2">
                <SportsSideMenu :type="eventDetails.sportName" :leagues_list="upcommingEvents"
                    @clicked="updateEventDetails" />
                    <div ref="printMe">
                <div class="col-12 col-sm-12 col-md-12">
                    <div class="tab-content">
                        <div class="play-online-tv-sec" v-if="showLiveTv">
                            <div class="live-tv">
                                <iframe :src='"https://vid.dreamcasino.live/GetAPI.html?MatchID=" + (eventDetails.tv_radar_id ? eventDetails.tv_radar_id : eventDetails.eventId)'
                                    scrolling="no" frameborder="0" class="tv-iframe"
                                    style="height: 235px !important; width: 100%;"></iframe>
                            </div>
                        </div>
                        <div class="leagues-details-sec" v-if="showScoreBoard">
                            <iframe id="sportradar_score"
                                :src="'https://scorecard.oddstrad.com/get-scorecard-iframe/' + eventDetails.sportId + '/' + eventDetails.eventId + '/' + eventDetails.sportsradar_id"
                                marginwidth="0" marginheight="0" frameborder="0" width="100%" scrolling="no"
                                allowfullscreen="allowfullscreen" style="height: 177px;"
                                class="sports-radar-scorecard-iframe"></iframe>
                        </div>
                        <div class="v-slide-group-wrapper">
                            <div class="market-open-tab-btn">
                                <div class="share-and-result">
                                    <div class="odds-match-filter">
                                        <button class="filted-disable-btn" v-if="!eventDetails?.is_exclusive"
                                            :class="eventDetailHideSections && eventDetailHideSections.length ? 'filter-sec hide-input-sec' : ''"
                                            data-bs-toggle="modal" data-bs-target="#filterModal">
                                            <img src="@/assets/images/filter-icon.webp" alt="filter-icon" class="inactive-filter">
                                            <img src="@/assets/images/active-filter.png" alt="active-filter" class="active-filter">
                                        </button>
                                    </div>
                                    <button type="button" data-bs-toggle="modal" data-bs-target="#shareBetModal" @click="resetCanvas()">
                                        <span class="share-icon-bg">
                                            <img loading="lazy" src="@/assets/images/share.webp" alt="share" />
                                        </span>
                                    </button>
                                    <button type="button" class="score-card-btn" @click="showScoreBoard = !showScoreBoard">
                                        <span class="show-score-card">
                                            <img v-if="showScoreBoard" src="@/assets/images/hidden.png" alt="hidden" />
                                            <img v-else src="@/assets/images/scoreicon.png" alt="scoreicon" />
                                            <span class="score-h">{{ $t('score','Score')}}</span>
                                        </span>
                                    </button>
                                </div>
                                <input type="radio" class="radio" name="radio" id="login" checked />
                                <input type="radio" class="radio" name="radio" id="signup" />
                                <label class="v-active-tab  login_tab market-v-tab" for="login" :class="{ active: activeMainTab === 'markets'}" @click="activeMainTab ='markets'">
                                    <span class="market-bets-icon">
                                        <img loading="lazy" src="@/assets/images/download.webp" alt="download" />
                                    </span>
                                    <span>{{ $t('market','Markets')}}</span>
                                </label>
                                <label class="v-active-tab  signup_tab open-bet-v-tab" for="signup" :class="{ active: activeMainTab === 'openBets'}" @click="activeMainTab ='openBets'" v-if="$auth.status && !eventDetails?.is_exclusive">
                                    <span class="open-bet-btn" >
                                        <img loading="lazy" src="@/assets/images/open-bets.webp" alt="open-bets" />
                                    </span>
                                    <span @click="getOpenBetsServiceCall()">{{ $t('open-bets','Open Bets')}}</span>
                                </label>

                                <div class="form_wrap" v-if="!eventDetails?.is_exclusive">
                                    <div class="form_fild login_form">
                                        <div class="book-maker-body mt-2" v-for="(market, m_index) in matchOddsData" :key="m_index">
                                            <template v-if="eventDetailHideSections && !eventDetailHideSections.includes('match_odds') && matchOddsData && matchOddsData.length>0 && !eventDetails?.is_exclusive">
                                                <template v-if="market.marketName == 'Match Odds' || market.marketName == 'Who Will Win The Match?'">
                                                    <div class="book-maker-details">
                                                        <div class="v-expansion-panel">
                                                            <div class="sub-title-sec">
                                                                <div class="inner-subtitle-menu">
                                                                    <div class="match-winner-text match-win-title">
                                                                        <span>{{ market.marketName == 'Who Will Win The Match?' &&  eventDetails.sportId == 4 ? market.marketName + ' (Inc Super Over)' : market.marketName }}</span>
                                                                    </div>
                                                                    <div class="cashout-cmn-btn"  v-if="$auth.status && (market.marketName == 'Match Odds' || (market.marketName == 'Who Will Win The Match?' && market.runners.length == 2))">
                                                                        <button type="button" v-if="!cashoutMarketData[market.mid] || (cashoutMarketData[market.mid] && !cashoutMarketData[market.mid].value)">
                                                                            <span class="cash-v-h"><img src="@/assets/images/money.webp" alt="money" /></span>
                                                                            <span class="cash-out-text disable-btn">{{ $t('cashout','Cashout')}}</span>
                                                                        </button>
                                                                        <button type="button" data-bs-target="#cashoutModal" data-bs-toggle="modal" @click="cashoutServiceCall(market, 'market')" v-else>
                                                                            <span class="cash-v-h"><img src="@/assets/images/money.webp" alt="money " /></span>
                                                                            <span class="cash-out-text ms-2" v-html="cashoutMarketData[market.mid].value"></span>
                                                                        </button>
                                                                        <div class="timer-sec">
                                                                            <div class="fast_bet_icon">
                                                                                <img loading="lazy" src="@/assets/images/fast.webp" alt="timer">
                                                                                <div class="tooltip-information-show">
                                                                                    <span><img loading="lazy" src="@/assets/images/fast.webp" alt="timer"> {{ market.bet_delay == 0 ? 'Instant Betting' : `${market.bet_delay} s`}}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="placed-bet-btn">
                                                                    <div class="back-and-lay-sec" v-if="market.marketName == 'Match Odds'">
                                                                        <span class="back-text">{{ $t('back','Back')}}</span>
                                                                        <span class="lay-text">{{ $t('lay','Lay')}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div v-if="market.marketName == 'Match Odds'">
                                                                <div class="team-bet-details-sec bet-slip-area"
                                                                v-for="(runner, r_index) in market.runners" :key="r_index">
                                                                <div class="row">
                                                                    <div class="col-7 col-sm-8 p-0">
                                                                        <div class="select-team-name">
                                                                            <span>{{ runner.runner_name }}</span>
                                                                            <p class="score-bottom"
                                                                                v-html="getRunnerBookHtml(market.mid, runner.sid, 'm')"></p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-5 col-sm-4 pr-0">
                                                                        <div class="v-suspended-main-container" >
                                                                            <div class="bet-details-container">
                                                                                <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                    @click="addBet(market, runner, 'back', 'market', r_index, $event)"
                                                                                    type="button" class="sky-blue-btn desktop-odd-btn">
                                                                                    <span>{{ runner.ex.b?.[2] ? getKFormatter(runner.ex.b?.[2].p) : '-'
                                                                                    }}</span>
                                                                                    <p class="light-text" v-if="runner.ex.b?.[2]">{{ runner.ex.b?.[2] ?
                                                                                        getKFormatter(runner.ex.b?.[2].s) : '' }}</p>
                                                                                </button>
                                                                                <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                    @click="addBet(market, runner, 'back', 'market', r_index, $event)"
                                                                                    type="button" class="sky-blue-btn desktop-odd-btn">
                                                                                    <span>{{ runner.ex.b?.[1] ? getKFormatter(runner.ex.b?.[1].p) : '-'
                                                                                    }}</span>
                                                                                    <p class="light-text" v-if="runner.ex.b?.[1]">{{ runner.ex.b?.[1] ?
                                                                                        getKFormatter(runner.ex.b?.[1].s) : '' }}</p>
                                                                                </button>
                                                                                <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                    @click="addBet(market, runner, 'back', 'market', r_index, $event)"
                                                                                
                                                                                    type="button" class="sky-blue-btn">
                                                                                    <span>{{ runner.ex.b?.[0] ? runner.ex.b?.[0].p : '-'
                                                                                    }}</span>
                                                                                    <p class="light-text" v-if="runner.ex.b?.[0]">{{ runner.ex.b?.[0] ?
                                                                                        getKFormatter(runner.ex.b?.[0].s) : '' }}</p>
                                                                                </button>
                                                                                <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                    @click="addBet(market, runner, 'lay', 'market', r_index, $event)"
                                                                                    type="button" class="pink-btn">
                                                                                    <span>{{ runner.ex.l?.[0] ? runner.ex.l?.[0].p : '-'
                                                                                    }}</span>
                                                                                    <p class="light-text" v-if="runner.ex.l?.[0]">{{ runner.ex.l?.[0] ?
                                                                                        getKFormatter(runner.ex.l?.[0].s) : '' }}</p>
                                                                                </button>
                                                                                <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                    @click="addBet(market, runner, 'lay', 'market', r_index, $event)"
                                                                                
                                                                                    type="button" class="pink-btn desktop-odd-btn">
                                                                                    <span>{{ runner.ex.l?.[1] ? getKFormatter(runner.ex.l?.[1].p) : '-'
                                                                                    }}</span>
                                                                                    <p class="light-text" v-if="runner.ex.l?.[1]">{{ runner.ex.l?.[1] ?
                                                                                        getKFormatter(runner.ex.l?.[1].s) : '' }}</p>
                                                                                </button>
                                                                                <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                    @click="addBet(market, runner, 'lay', 'market', r_index, $event)"


                                                                                    type="button" class="pink-btn desktop-odd-btn">
                                                                                    <span>{{ runner.ex.l?.[2] ? getKFormatter(runner.ex.l?.[2].p) : '-'
                                                                                    }}</span>
                                                                                    <p class="light-text" v-if="runner.ex.l?.[2]">{{ runner.ex.l?.[2] ?
                                                                                        getKFormatter(runner.ex.l?.[2].s) : '' }}</p>
                                                                                </button>
                                                                                <div v-if="market.st != 'OPEN'" class="v-overlap suspended">
                                                                                <span class="v-suspended-content">
                                                                                    <span>{{ $t('suspended','SUSPENDED')}}</span>
                                                                                </span>
                                                                            </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="marquee-show-msg" v-if="market?.msg || (market?.msg && market?.msg != '')">
                                                                <div class="msgs" style="width: 100vw">
                                                                    <marquee>
                                                                        <i class="mdi mdi-email mr-1"></i> {{ market?.msg }}
                                                                    </marquee>
                                                                </div>
                                                            </div>
                                                            </div>
                                                            <div v-else class="team-bet-details-sec bet-slip-area nw-who-win-wrapper">
                                                                <div class="who-win-sec">
                                                                    <div v-for="(runner , r_index) in market.runners" :key="r_index" class="win-col-box">
                                                                        <div class="select-team-name">
                                                                                <span>{{ runner.runner_name }}</span>
                                                                                <p class="score-bottom" v-html="getRunnerBookHtml(market.mid, runner.sid, 'm')"></p>
                                                                        </div>
                                                                        <button @click="addBet(market, runner, 'back', 'market', r_index, $event)" type="button" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100" class="sky-blue-btn"
                                                                        :class="{'opacity-25': market?.min_stake_limit < 100 || market?.stake_limit < 100, 'win-active-box': betDetails && betDetails.runner_selection_id == runner.sid && betDetails.market.marketName == 'Who Will Win The Match?'}"
                                                                        >
                                                                            <span>{{ runner.ex.b?.[0] ? runner.ex.b?.[0].p : '-'}}</span>
                                                                            <p class="light-text" v-if="runner.ex.b?.[0]">{{ runner.ex.b?.[0] ? getKFormatter(runner.ex.b?.[0].s) : '' }}</p>
                                                                        </button>
                                                                        <div class="v-overlap suspended" v-if="market.st != 'OPEN'">
                                                                            <span class="v-suspended-content">
                                                                                <span>{{ $t('suspended','SUSPENDED')}}</span>
                                                                            </span>
                                                                        </div>    
                                                                    </div>
                                                                </div>                                     
                                                            </div>
                                                            
                                                            <div class="team-bet-details-sec">
                                                                <div class="row">
                                                                    <div class="col-12 text-end">
                                                                        <div class="min-max-h">
                                                                            <span class="light-text">{{ $t('min','min')}}: {{ market.min_stake_limit ?
                                                                                market.min_stake_limit : 0 }}</span>
                                                                            <img loading="lazy" src="@/assets/images/min-max-icon.svg" alt="min-max-icon">
                                                                            <span class="light-text">{{ $t('max','max')}}: {{ market.stake_limit ?
                                                                                market.stake_limit : '0' }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                            
                                        </div>
                                        <template
                                            v-if="bookmakerData && bookmakerData.ml && eventDetailHideSections && !eventDetailHideSections.includes('bookmakers') && !eventDetails?.is_exclusive">
                                            <template v-if="bookmakerData && bookmakerData.ml">
                                                <div class="book-maker-body mt-2" v-for="(bookmaker, b_index) in bookmakerData.ml"
                                                    :key="b_index">
                                                    <div class="book-maker-details">
                                                        <div class="v-expansion-panel">
                                                            <div class="sub-title-sec">
                                                                <div class="inner-subtitle-menu">
                                                                    <div class="match-winner-text match-win-title">
                                                                        <span>{{ bookmaker.mn }}</span>
                                                                    </div>
                                                                        <div class="cashout-cmn-btn">
                                                                            <template v-if="$auth.status && bookmaker?.sl?.length <= 2">
                                                                                <button type="button" v-if="!cashoutMarketData[bookmaker.mi] || (cashoutMarketData[bookmaker.mi] && !cashoutMarketData[bookmaker.mi].value)">
                                                                                    <span class="cash-v-h"><img src="@/assets/images/money.webp" alt="money" /></span>
                                                                                    <span class="cash-out-text disable-btn">{{ $t('cashout','Cashout')}}</span>
                                                                                </button>
                                                                                <button type="button" data-bs-target="#cashoutModal" data-bs-toggle="modal" @click="cashoutServiceCall(bookmaker, 'bookmaker')" v-else>
                                                                                    <span class="cash-v-h"><img src="@/assets/images/money.webp" alt="money" /></span>
                                                                                    <span class="cash-out-text ms-2"  v-html="cashoutMarketData[bookmaker.mi].value" ></span>
                                                                                </button>
                                                                            </template>
                                                                        <div class="timer-sec">
                                                                            <div class="fast_bet_icon">
                                                                                <img loading="lazy" src="@/assets/images/fast.webp" alt="timer">
                                                                                <div class="tooltip-information-show">
                                                                                    <span><img loading="lazy" src="@/assets/images/fast.webp" alt="timer"> {{ bookmaker.bd == 0 ? 'Instant Bettting' : `${bookmaker.bd} s`}} </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="placed-bet-btn">
                                                                    <div class="back-and-lay-sec">
                                                                        <span class="back-text">{{ $t('back','Back')}}</span>
                                                                        <span class="lay-text">{{ $t('lay','Lay')}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="team-bet-details-sec bet-slip-area"
                                                                v-for="(runner, r_index) in bookmaker.sl" :key="r_index">
                                                                <div class="row">
                                                                    <div class="col-7 col-sm-8 p-0">
                                                                        <div class="select-team-name">
                                                                            <span>{{ runner.sln }}</span>
                                                                            <p class="score-bottom"
                                                                                v-html="getRunnerBookHtml(bookmaker.mi, runner.si, 'b')"></p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-5 col-sm-4 pr-0">
                                                                        <div class="v-suspended-main-container">
                                                                            <div class="bet-details-container">
                                                                                <!-- <div v-if="runner.ss=='SUSPEND' || bookmaker.sn == 'SUSPEND'"  class="suspend-box">suspended</div> -->
                                                                                <button type="button" class="sky-blue-btn desktop-odd-btn">
                                                                                    <span>-</span>
                                                                                    <p class="light-text">-</p>
                                                                                </button>
                                                                                <button type="button" class="sky-blue-btn desktop-odd-btn">
                                                                                    <span>-</span>
                                                                                    <p class="light-text">-</p>
                                                                                </button>
                                                                                <button :class="{'opacity-25' : bookmaker?.mins < 100 || bookmaker?.ms < 100}" :disabled="bookmaker?.mins < 100 || bookmaker?.ms < 100"
                                                                                    @click="addBet(bookmaker, runner, 'back', 'bookmaker', r_index, $event)"
                                                                                    type="button" class="sky-blue-btn">
                                                                                    <span>{{ runner.b ? runner.b : '-' }}</span>
                                                                                    <p class="light-text" v-if="runner.b">{{ bookmaker.ms ? getKFormatter(bookmaker.ms) : '' }}</p>
                                                                                </button>
                                                                                <button :class="{'opacity-25' : bookmaker?.mins < 100 || bookmaker?.ms < 100}" :disabled="bookmaker?.mins < 100 || bookmaker?.ms < 100"
                                                                                    @click="addBet(bookmaker, runner, 'lay', 'bookmaker', r_index, $event)"
                                                                                    type="button" class="pink-btn">
                                                                                    <span>{{ runner.l ? runner.l : '-' }}</span>
                                                                                    <p class="light-text" v-if="runner.l">{{ bookmaker.ms ? getKFormatter(bookmaker.ms) : '' }}</p>
                                                                                </button>
                                                                                <button type="button" class="pink-btn desktop-odd-btn">
                                                                                    <span>-</span>
                                                                                    <p class="light-text"></p>
                                                                                </button>
                                                                                <button type="button" class="pink-btn desktop-odd-btn">
                                                                                    <span>-</span>
                                                                                    <p class="light-text"></p>
                                                                                </button>
                                                                                <div v-if="bookmaker.sn != 'ONLINE' || runner.ss != 'ACTIVE'"
                                                                                class="v-overlap suspended">
                                                                                <span class="v-suspended-content">
                                                                                    <span>{{ $t('suspended','SUSPENDED')}}</span>
                                                                                </span>
                                                                            </div>
                                                                            </div>
                                                                            
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="team-bet-details-sec">
                                                                <div class="row">
                                                                    <div class="col-12 text-end">
                                                                        <div class="min-max-h">
                                                                            <span class="light-text">{{ $t('min','min')}}: {{ bookmaker.mins ? bookmaker.mins :
                                                                                0 }}</span>
                                                                            <img loading="lazy" src="@/assets/images/min-max-icon.svg" alt="min-max-icon">
                                                                            <span class="light-text">{{ $t('max','max')}}: {{ bookmaker.ms ? bookmaker.ms :
                                                                                0 }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="marquee-show-msg" v-if=" bookmaker?.msg || (bookmaker?.msg && bookmaker?.msg != '') ">
                                                                <div class="msgs" style="width: 100vw">
                                                                    <marquee>
                                                                        <i class="mdi mdi-email mr-1"></i> {{ bookmaker?.msg }}
                                                                    </marquee>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                        <template  v-if="!eventDetails?.is_exclusive" >
                                            <div class="fancy-and-primeum-tabs">
                                                <div class="v-slide-group-wrapper mb-2">
                                                    <ul class="nav nav-pills" id="pills-tab" role="tablist" v-if="eventDetails.hasPremiumFancy && checkForPremiumFancyEvent() && !eventDetailHideSections.includes('fancy_filters') && eventDetails.hasFancy && !eventDetails?.is_exclusive">
                                                        <!-- <li class="nav-item" role="presentation"
                                                            v-if="eventDetails.hasFancy && fancyData && fancyData.ml && !eventDetailHideSections.includes('fancy_filters')">
                                                            <button class="nav-link" @click="selectFancyTab('Fancy')" id="pills-home-tab"
                                                                data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab"
                                                                aria-controls="pills-home" aria-selected="true"   :class="{ 'active': selectedFancyTab == 'Fancy' && selectedFancyCategory.value == 'all' }">{{ $t('fancy','Fancy') }}</button>
                                                        </li>
                                                        <li class="nav-item" role="presentation" @click="selectFancyTab('premiumFancy')"  
                                                            v-if="(eventDetails.hasPremiumFancy && checkForPremiumFancyEvent) && !eventDetailHideSections.includes('premiumfancy_filters')">
                                                            <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
                                                                data-bs-target="#pills-profile" type="button" role="tab"
                                                                aria-controls="pills-profile" aria-selected="false"  :class="{ 'active': (selectedFancyTab == 'premiumFancy') }">
                                                                {{ $t('premium','Premium')}} {{ $t('fancy','Fancy') }}
                                                            </button>
                                                        </li> -->
                                                        <template v-for="(fData, index) in fancyCategories" :key="index">
                                                            <li class="nav-item" role="presentation" v-if="(fData.value == 'premium_fancy' && fData.isPremiumAvailable) || fData.value != 'premium_fancy'" @click="changeFancyCategory(fData)">
                                                                <button class="nav-link" data-bs-toggle="pill" data-bs-target="#pills-home"
                                                                    :class="fData.value == selectedFancyCategory?.value ? 'active' : ''" type="button" role="tab">
                                                                    {{ $t(fData.key,fData.title) }}
                                                                </button>
                                                            </li>
                                                        </template>
                                                    </ul>
                                                </div>
                                                <div class="tab-content fancy-premium-main-container" id="pills-tabContent">

                                                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                                                        aria-labelledby="pills-home-tab" tabindex="0">
                                                        
                                                        <div class="tab-content" id="pills-tabContent">
                                                            <div class="tab-pane fade show active" id="pills-fancy-1" role="tabpanel"
                                                                aria-labelledby="pills-fancy-1-tab">
                                                                <div class="book-maker-body" v-if="eventDetailHideSections && eventDetails.hasFancy && !eventDetailHideSections.includes('fancy_filters') && (selectedFancyTab == 'Fancy' || !isPremium) && !eventDetails?.is_exclusive">
                                                                    <div class="book-maker-details">
                                                                        <!-- Pinned Fancy -->
                                                                        <template v-if="getPinnedFancies?.length">
                                                                            <!-- <div class="pinfancy-header-title">
                                                                                <div class="match-winner-text match-win-title">
                                                                                    <span>{{$t("pin-fancy-market","Pin Fancy Market")}}</span>
                                                                                </div>
                                                                                <div class="back-and-lay-sec-fancy">
                                                                                    <span>{{ $t("no","No") }}</span>
                                                                                    <span>{{ $t('yes','Yes')}}</span>
                                                                                </div>
                                                                            </div> -->
                                                                            <div class="v-expansion-panel" v-for="(fancy, f_index) in getPinnedFancies" :key="f_index">
                                                                                <div class="team-bet-details-sec bet-slip-area">
                                                                                    <div id="getMobilePopuplay">
                                                                                        <div class="mobile-bet-popup"></div>
                                                                                    </div>
                                                                                    <div class="fancy-odds-row">
                                                                                        <div class="fancy-col-left">
                                                                                            <div class="fancy-tab-lft-content">
                                                                                                <div class="fancy_wishlist_title-left">
                                                                                                    <div class="pined-fancy-btn">
                                                                                                        <button @click="pinUnpinFancy(fancy)" v-if="pinnedFancies.includes(fancy?.mi)" class="wishlist-btn">
                                                                                                            <i class="fa fa-star"></i>
                                                                                                        </button>
                                                                                                        <button @click=" pinUnpinFancy(fancy) " v-else class="wishlist-btn">
                                                                                                            <i class="fa-regular fa-star"></i>
                                                                                                        </button>
                                                                                                        <span>{{ fancy.mn }}</span>
                                                                                                    </div>
                                                                                                    <p class="score-bottom nagative-value" v-html="getRunnerBookHtml(fancy?.mi, fancy?.mi, 'f')"></p>
                                                                                                </div>
                                                                                                <div class="fancy-ladder-row">
                                                                                                    <div class="fancy-green-icon" v-if="fancy?.com">
                                                                                                        <i><img src="@/assets/images/fancy-green-icon.webp" alt="fancy-green-icon" title="" /></i>
                                                                                                    </div>
                                                                                                    <div class="ladder_icon" @click="getfancyBook(fancy?.mi, fancy?.mn)" v-if="getRunnerBookHtml(fancy?.mi, fancy?.mi, 'f')">
                                                                                                        <img src="@/assets/images/ladder.png">
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="fancy-col-right">
                                                                                            <div class="v-suspended-main-container">
                                                                                                <div class="bet-details-container">
                                                                                                    <div class="hover-div-contant">
                                                                                                        <button type="button"
                                                                                                            class="info-to-show-min-max">
                                                                                                            <img loading="lazy" src="@/assets/images/info-icon.webp"
                                                                                                                alt="info">
                                                                                                        </button>
                                                                                                        <div class="text-on-hover">
                                                                                                            <div class="min-max-h">
                                                                                                                <span
                                                                                                                    class="light-text">{{ $t('min','min')}}:
                                                                                                                    {{ fancy.mins ?
                                                                                                                        fancy.mins : 0 }}</span>
                                                                                                                <img loading="lazy" src="@/assets/images/min-max-icon.svg"
                                                                                                                    alt="min-max-icon">
                                                                                                                <span
                                                                                                                    class="light-text">{{ $t('max','max')}}:
                                                                                                                    {{ fancy.ms ? fancy.ms :
                                                                                                                        0 }}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <button :class="{'opacity-25' : fancy?.mins < 100 || fancy?.ms < 100}" :disabled="fancy?.mins < 100 || fancy?.ms < 100"
                                                                                                        @click="addBet(fancy, fancy, 'lay', 'fancy', 0, $event)"
                                                                                                        type="button" class="pink-btn">
                                                                                                        <span>{{ fancy.rn ? fancy.rn : '-' }}</span>
                                                                                                        <p class="light-text" v-if="fancy.rn">{{ fancy.on ? fancy.on : '' }}
                                                                                                        </p>
                                                                                                    </button>
                                                                                                    <button :class="{'opacity-25' : fancy?.mins < 100 || fancy?.ms < 100}" :disabled= "fancy?.mins < 100 || fancy?.ms < 100"
                                                                                                        @click="addBet(fancy, fancy, 'back', 'fancy', 0, $event)"
                                                                                                        type="button" class="sky-blue-btn">
                                                                                                        <span>{{ fancy.ry ? fancy.ry : '-' }}</span>
                                                                                                        <p class="light-text" v-if="fancy.ry">{{ fancy.oy ? fancy.oy : '' }}
                                                                                                        </p>
                                                                                                    </button>
                                                                                                    <div v-if="fancy.sn == 'SUSPEND' || fancy.sn == 'BALL_RUN'"
                                                                                                    class="v-overlap suspended">
                                                                                                    <span class="v-suspended-content">
                                                                                                        <span>{{ $t('ball-running','Ball Running')}}</span>
                                                                                                    </span>
                                                                                                </div>
                                                                                                </div>
                                                                                                
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="marquee-show-msg" v-if=" fancy?.msg || (fancy?.msg && fancy?.msg != '') ">
                                                                                            <div class="msgs" style="width: 100vw">
                                                                                                <marquee>
                                                                                                    <i class="mdi mdi-email mr-1"></i> {{ fancy?.msg }}
                                                                                                </marquee>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                        <!-- Unpinned Fancy -->
                                                                        <template v-if="filteredFancyList && filteredFancyList?.length > 0">
                                                                            <div class="v-expansion-panel mt-2"
                                                                                v-for="(fancyCat, fc_index) in filteredFancyList" :key="fc_index">
                                                                                <template v-if="fancyCat.fancies && fancyCat.fancies.length">
                                                                                    <!-- <div class="sub-title-sec">
                                                                                        <div class="inner-subtitle-menu">
                                                                                            <div class="match-winner-text match-win-title">
                                                                                                <span>{{ fancyCat.title }}</span>
                                                                                            </div>
                                                                                            <span class="fancy-timer-sec">
                                                                                                <button type="button" class="bookmake-wiiner-btn" tooltip="I'm up above it!">
                                                                                                    <img loading="lazy" src="@/assets/images/fast.webp" alt="fast" />
                                                                                                </button>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div class="placed-bet-btn">
                                                                                            <div class="back-and-lay-sec-fancy">
                                                                                                <span class="back-text">{{ $t('no','No')}}</span>
                                                                                                <span class="lay-text">{{ $t('yes','Yes')}}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div> -->
                                                                                    <template v-for="(fancy, f_index) in fancyCat.fancies"
                                                                                        :key="f_index">
                                                                                        <div class="team-bet-details-sec bet-slip-area">
                                                                                            <div id="getMobilePopuplay">
                                                                                                <div class="mobile-bet-popup"></div>
                                                                                            </div>

                                                                                            <div class="fancy-odds-row">
                                                                                                <div class="fancy-col-left">
                                                                                                    <div class="fancy-tab-lft-content">
                                                                                                        <div class="fancy_wishlist_title-left">
                                                                                                            <div class="pined-fancy-btn">
                                                                                                                <button @click="pinUnpinFancy(fancy)" v-if="pinnedFancies.includes(fancy?.mi)" class="wishlist-btn">
                                                                                                                    <i class="fa fa-star"></i>
                                                                                                                </button>
                                                                                                                <button @click=" pinUnpinFancy(fancy) " v-else class="wishlist-btn">
                                                                                                                    <i class="fa-regular fa-star"></i>
                                                                                                                </button>
                                                                                                                <span>{{ fancy.mn }}</span>
                                                                                                            </div>
                                                                                                            <p class="score-bottom nagative-value" v-html="getRunnerBookHtml(fancy.mi, fancy.mi, 'f')"></p>
                                                                                                        </div>
                                                                                                        <div class="fancy-ladder-row">
                                                                                                            <div class="fancy-green-icon" v-if="fancy?.com">
                                                                                                                <i><img src="@/assets/images/fancy-green-icon.webp" alt="fancy-green-icon" title="" /></i>
                                                                                                            </div>
                                                                                                            <div class="ladder_icon" @click="getfancyBook(fancy?.mi, fancy?.mn)" v-if="getRunnerBookHtml(fancy.mi, fancy.mi, 'f')">
                                                                                                                <img src="@/assets/images/ladder.png">
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="fancy-col-right">
                                                                                                    <div class="v-suspended-main-container">
                                                                                                        <div class="bet-details-container">
                                                                                                            <div class="hover-div-contant">
                                                                                                                <button type="button"
                                                                                                                    class="info-to-show-min-max">
                                                                                                                    <img loading="lazy" src="@/assets/images/info-icon.webp"
                                                                                                                        alt="info">
                                                                                                                </button>
                                                                                                                <div class="text-on-hover">
                                                                                                                    <div class="min-max-h">
                                                                                                                        <span
                                                                                                                            class="light-text">{{ $t('min','min')}}:
                                                                                                                            {{ fancy.mins ?
                                                                                                                                fancy.mins : 0 }}</span>
                                                                                                                        <img loading="lazy" src="@/assets/images/min-max-icon.svg"
                                                                                                                            alt="min-max-icon">
                                                                                                                        <span
                                                                                                                            class="light-text">{{ $t('max','max')}}:
                                                                                                                            {{ fancy.ms ? fancy.ms :
                                                                                                                                0 }}</span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <button :class="{'opacity-25' : fancy?.mins < 100 || fancy?.ms < 100}" :disabled="fancy?.mins < 100 || fancy?.ms < 100"
                                                                                                                @click="addBet(fancy, fancy, 'lay', 'fancy', 0, $event)"
                                                                                                                type="button" class="pink-btn">
                                                                                                                <span>{{ fancy.rn ? fancy.rn : '-' }}</span>
                                                                                                                <p class="light-text" v-if="fancy.rn">{{ fancy.on ? fancy.on : '' }}
                                                                                                                </p>
                                                                                                            </button>
                                                                                                            <button :class="{'opacity-25' : fancy?.mins < 100 || fancy?.ms < 100}" :disabled= "fancy?.mins < 100 || fancy?.ms < 100"
                                                                                                                @click="addBet(fancy, fancy, 'back', 'fancy', 0, $event)"
                                                                                                                type="button" class="sky-blue-btn">
                                                                                                                <span>{{ fancy.ry ? fancy.ry : '-' }}</span>
                                                                                                                <p class="light-text" v-if="fancy.ry">{{ fancy.oy ? fancy.oy : '' }}
                                                                                                                </p>
                                                                                                            </button>
                                                                                                            <div v-if="fancy.sn == 'SUSPEND' || fancy.sn == 'BALL_RUN'"
                                                                                                            class="v-overlap suspended">
                                                                                                            <span class="v-suspended-content">
                                                                                                                <span>{{ $t('ball-running','Ball Running')}}</span>
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        </div>
                                                                                                        
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="marquee-show-msg" v-if=" fancy?.msg || (fancy?.msg && fancy?.msg != '') ">
                                                                                                    <div class="msgs" style="width: 100vw">
                                                                                                        <marquee>
                                                                                                            <i class="mdi mdi-email mr-1"></i> {{ fancy?.msg }}
                                                                                                        </marquee>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </template>
                                                                                </template>
                                                                                <!-- if particular market is not available -->
                                                                                <template
                                                                                        v-if="selectedFancyCategory.value != 'all' && fancyCat.fancies.length == 0">
                                                                                        <div class="text-center w-100 py-3">{{ $t('market-unavail','This Market Is Not Available Right Now')}}</div>
                                                                                </template>
                                                                            </div>
                                                                        </template>
                                                                        <template v-else-if="filteredFancyList && filteredFancyList?.length == 0" >
                                                                            <div class="no-real-time text-white"> {{ $t('this-market-is-not-available-right-now','This Market Is Not Available Right Now')}}</div>
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade" :class="((selectedFancyTab == 'premiumFancy' || (eventDetails?.hasPremiumFancy && !eventDetails.hasFancy)) && eventDetailHideSections && !eventDetailHideSections.includes('hide-fancy-tabs')) ? 'active show' : ''" 
                                                        id="pills-profile" role="tabpanel" v-if="eventDetails.hasPremiumFancy && checkForPremiumFancyEvent() && eventDetailHideSections && !eventDetailHideSections.includes('fancy_filters')" aria-labelledby="pills-profile-tab" tabindex="0">
                                                        <iframe class="fancy-iframe" v-if="premiumFancyUrl" :src="premiumFancyUrl"></iframe>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-if="eventDetailHideSections && !eventDetailHideSections.includes('othermarkets_filters') && otherMarkets && otherMarkets.length>0">
                                            <div class="book-maker-body mt-2" v-for="(market, m_index) in otherMarkets"
                                                :key="m_index">
                                                <template v-if="market.marketName != 'Match Odds'">
                                                    <div class="book-maker-details">
                                                        <div class="v-expansion-panel">
                                                            <div class="sub-title-sec">
                                                                <div class="inner-subtitle-menu">
                                                                    <div class="match-winner-text match-win-title">
                                                                        <span>{{ market.marketName }}</span>
                                                                    </div>
                                                                    <div class="cashout-cmn-btn" v-if="$auth.status">
                                                                        <button type="button" v-if="!cashoutMarketData[market.mid] || (cashoutMarketData[market.mid] && !cashoutMarketData[market.mid].value)">
                                                                            <span class="cash-v-h"><img src="@/assets/images/money.webp" alt="money" /></span>
                                                                            <span class="cash-out-text">{{ $t('cashout','Cashout')}}</span>
                                                                        </button>
                                                                        <button type="button" data-bs-target="#cashoutModal" data-bs-toggle="modal" @click="cashoutServiceCall(market, 'market')" v-else>
                                                                            <span class="cash-v-h"><img src="@/assets/images/money.webp" alt="money" /></span>
                                                                            <span class="cash-out-text ms-2" v-html="cashoutMarketData[market.mid].value"></span>
                                                                        </button>
                                                                        <div class="timer-sec">
                                                                            <div class="timer-sec">
                                                                                <div class="fast_bet_icon">
                                                                                    <img loading="lazy" src="@/assets/images/fast.webp" alt="timer">
                                                                                    <div class="tooltip-information-show">
                                                                                        <span><img loading="lazy" src="@/assets/images/fast.webp" alt="timer"> {{ market.bet_delay == 0 ? 'Instant Betting' : `${market.bet_delay} s`}} </span>
                                                                                    </div>
                                                                                </div>     
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                </div>
                                                                <div class="placed-bet-btn">
                                                                    <div class="back-and-lay-sec">
                                                                        <span class="back-text">{{ $t('back','Back')}}</span>
                                                                        <span class="lay-text">{{ $t('lay','Lay')}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="team-bet-details-sec bet-slip-area"
                                                                v-for="(runner, r_index) in market.runners" :key="r_index">
                                                                <div class="row">
                                                                    <div class="col-7 col-sm-8 p-0">
                                                                        <div class="select-team-name">
                                                                            <span>{{ runner.runner_name }}</span>
                                                                            <p class="score-bottom"
                                                                                v-html="getRunnerBookHtml(market.mid, runner.sid, 'm')">
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-5 col-sm-4 pr-0">
                                                                        <div class="bet-details-container">
                                                                            <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                @click="addBet(market, runner, 'back', 'market', r_index, $event)"
                                                                                type="button" class="sky-blue-btn desktop-odd-btn">
                                                                                <span>{{ runner.ex.b?.[2] ? getKFormatter(runner.ex.b?.[2].p) :
                                                                                    '-' }}</span>
                                                                                <p class="light-text" v-if="runner.ex.b?.[2]">{{ runner.ex.b?.[2] ?
                                                                                    runner.ex.b?.[2].s : '-' }}</p>
                                                                            </button>
                                                                            <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                @click="addBet(market, runner, 'back', 'market', r_index, $event)"
                                                                                type="button" class="sky-blue-btn desktop-odd-btn">
                                                                                <span>{{ runner.ex.b?.[1] ? getKFormatter(runner.ex.b?.[1].p) : '-'
                                                                                }}</span>
                                                                                <p class="light-text" v-if="runner.ex.b?.[1]">{{ runner.ex.b?.[1] ?
                                                                                    runner.ex.b?.[1].s : '-' }}</p>
                                                                            </button>
                                                                            <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                @click="addBet(market, runner, 'back', 'market', r_index, $event)"
                                                                                type="button" class="sky-blue-btn">
                                                                                <span>{{ runner.ex.b?.[0] ? getKFormatter(runner.ex.b?.[0].p) : '-'
                                                                                }}</span>
                                                                                <p class="light-text" v-if="runner.ex.b?.[0]">{{ runner.ex.b?.[0] ?
                                                                                    getKFormatter(runner.ex.b?.[0].s) : '-' }}</p>
                                                                            </button>
                                                                            <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                @click="addBet(market, runner, 'lay', 'market', r_index, $event)"
                                                                                type="button" class="pink-btn">
                                                                                <span>{{ runner.ex.l?.[0] ? getKFormatter(runner.ex.l?.[0].p) : '-'
                                                                                }}</span>
                                                                                <p class="light-text" v-if="runner.ex.l?.[0]">{{ runner.ex.l?.[0] ?
                                                                                    getKFormatter(runner.ex.l?.[0].s) : '-' }}</p>
                                                                            </button>
                                                                            <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                @click="addBet(market, runner, 'lay', 'market', r_index, $event)"
                                                                                type="button" class="pink-btn desktop-odd-btn">
                                                                                <span>{{ runner.ex.l?.[1] ? getKFormatter(runner.ex.l?.[1].p) : '-'
                                                                                }}</span>
                                                                                <p class="light-text" v-if="runner.ex.l?.[1]">{{ runner.ex.l?.[1] ?
                                                                                    getKFormatter(runner.ex.l?.[1].s) : '-' }}</p>
                                                                            </button>
                                                                            <button :class="{'opacity-25' : market?.min_stake_limit < 100 || market?.stake_limit < 100}" :disabled="market?.min_stake_limit < 100 || market?.stake_limit < 100"
                                                                                @click="addBet(market, runner, 'lay', 'market', r_index, $event)"
                                                                                type="button" class="pink-btn desktop-odd-btn">
                                                                                <span>{{ runner.ex.l?.[2] ? getKFormatter(runner.ex.l?.[2].p) : '-'
                                                                                }}</span>
                                                                                <p class="light-text" v-if="runner.ex.l?.[2]">{{ runner.ex.l?.[2] ?
                                                                                    getKFormatter(runner.ex.l?.[2].s) : '-' }}</p>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="team-bet-details-sec">
                                                                <div class="row">
                                                                    <div class="col-12 text-end">
                                                                        <div class="min-max-h">
                                                                            <span class="light-text">{{ $t('min','min')}}: {{ market.min_stake_limit
                                                                                ?
                                                                                market.min_stake_limit : 0 }}</span>
                                                                            <img loading="lazy" src="@/assets/images/min-max-icon.svg" alt="min-max-icon">
                                                                            <span class="light-text">{{ $t('max','max')}}: {{ market.stake_limit ?
                                                                                market.stake_limit : '0' }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </template>
                                        <template v-if="!eventDetails?.matchOddData.length && !Object.keys(eventDetails?.bookmakerOddData).length && !Object.keys(eventDetails?.fancyOddData).length && !eventDetails.hasPremiumFancy">
                                            <NoDataFound></NoDataFound>
                                        </template>
                                    </div>
                                    <div class="form_fild signup_form">
                                        <div class="open-bet-details-m"> 
                                            <div class="information-modal-wrapper">
                                                <div class="mobile-show-bet-content">
                                                    <div class="show-and-hide-tabs">
                                                        <div class="accordion" id="accordionPanelsStayOpenExample">
                                                            <div class="accordion-item">
                                                                <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                                        data-bs-target="#panelsStayOpen-collapseTwo2" aria-expanded="true"
                                                                        aria-controls="panelsStayOpen-collapseTwo2">
                                                                        {{ $t('matched-bets','Matched Bets')}}
                                                                    </button>
                                                                </h2>
                                                                <div id="panelsStayOpen-collapseTwo2"
                                                                    class="accordion-collapse collapse show"
                                                                    aria-labelledby="panelsStayOpen-headingTwo">
                                                                    <div class="accordion-body controler-body">
                                                                        <div class="controls-input">
                                                                            <div class="average-match-h">
                                                                                <input class="form-check-input" type="checkbox"
                                                                                    :checked="averageOdds"
                                                                                    @change="averageOdds = !averageOdds">
                                                                                <label>{{ $t('average-odds','Average Odds')}}</label>
                                                                            </div>
                                                                        </div>
                                                                        <template v-if="openBetsList?.length > 0">
                                                                            <div class="table-match-data score-table demo-tabel"
                                                                                v-for="(event, event_index) in openBetsList" :key="event_index">
                                                                                <div class="caption font-bold-hide-show"
                                                                                    v-if="event.main_market?.length || event.bookmakers?.length || event.fancies?.length">
                                                                                    {{ event.event_name }}
                                                                                </div>
                                                                                <template v-if="!averageOdds">
                                                                                    <template  v-if="event.main_market?.length > 0">
                                                                                        <div class="match-bookmakker-h">
                                                                                                
                                                                                            <h5>{{ $t('main-market','Main Market')}}</h5>
                                                                                        </div>
                                                                                        <template v-for="(type, t_index) in event?.main_market" :key="t_index">
                                                                                            <div class="match-bookmaker-details relative_cashout_accordian"
                                                                                                :class="type.selection_type == 'back' ? 'back' : 'lay'">
                                                                                                <span v-if="type?.is_cashout" class="cashout-Box">C</span>
                                                                                                <span class="text-captiliaze fw-bold"> {{ getBetHeadingForSports(type) }} </span>
                                                                                                <p>{{ $t('placed','Placed')}} 
                                                                                                    {{ openBetTimeConverter(type.bet_timestamp_date)
                                                                                                    }}
                                                                                                </p>
                                                                                            </div>
                                                                                        </template>
                                                                                    </template>
                                                                                    <template v-if="event.bookmakers?.length > 0">
                                                                                        <div class="match-bookmakker-h">
                                                                                            <h5>{{ $t('bookmaker','Bookmaker')}} </h5>
                                                                                        </div>
                                                                                        <template v-for="(type, t_index) in event?.bookmakers" :key="t_index" >
                                                                                            <div class="match-bookmaker-details" :class="type.selection_type == 'back' ? 'back' : 'lay'">
                                                                                                <span class="text-captiliaze fw-bold"> {{ getBetHeadingForSports(type) }} </span>
                                                                                                <span><td><span v-if="type?.is_cashout" class="cashout-Box"> C </span></td></span>
                                                                                                <p>{{ $t('placed','Placed')}} 
                                                                                                    {{ openBetTimeConverter(type.bet_timestamp_date)
                                                                                                    }}
                                                                                                </p>
                                                                                            </div>
                                                                                        </template>
                                                                                    </template>
                                                                                    <template v-if="event.fancies?.length > 0">
                                                                                        <div class="match-bookmakker-h">
                                                                                            <h5>{{ $t('fancy','Fancy')}} </h5>
                                                                                        </div>
                                                                                        <template v-for="(type, t_index) in event?.fancies" :key="t_index"> 
                                                                                            <div class="match-bookmaker-details"
                                                                                                :class="type.selection_type == 'back' ? 'back' : 'lay'">
                                                                                                <span class="text-captiliaze fw-bold"> {{ getBetHeadingForSports(type) }} </span>
                                                                                                <p>{{ $t('placed','Placed')}} 
                                                                                                    {{ openBetTimeConverter(type.bet_timestamp_date)
                                                                                                    }}
                                                                                                </p>
                                                                                            </div>
                                                                                        </template>
                                                                                    </template>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <template
                                                                                        v-for="(item, index) in getBetandAvgOdds"
                                                                                        :key="index">
                                                                                        <template v-if="(getMarketDataByName(item.market).lay?.betCount + getMarketDataByName(item.market).back?.betCount) > 0">
                                                                                            <div class="match-bookmakker-h">
                                                                                                <h5>{{ item.market}} </h5>
                                                                                            </div>
                                                                                            <div class="v-data-table">
                                                                                                <div class="table-responsive">
                                                                                                    <table class="table">
                                                                                                        <thead>
                                                                                                            <tr>
                                                                                                                <th class="text-left">{{ $t('selection','Selection')}} </th>
                                                                                                                <th class="text-left">{{ $t('odds','Odds')}} </th>
                                                                                                                <th class="text-left">{{ $t('stake','Stake')}}</th>
                                                                                                                <th class="text-left">{{ $t('profit-liability','Profit/Liability') }}</th>
                                                                                                            </tr>
                                                                                                        </thead>
                                                                                                        <tbody>
                                                                                                            <tr class="b_data lay">
                                                                                                                <td class="caption font-weight-bold">{{$t('lay', 'Lay')}}</td>
                                                                                                                <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).lay.odds }}</td>
                                                                                                                <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).lay.stake }}</td>
                                                                                                                <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).lay.pl }}</td>
                                                                                                            </tr>
                                                                                                            <tr class="b_data back">
                                                                                                                <td class="caption font-weight-bold">{{$t('back', 'Back')}}</td>
                                                                                                                <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).back.odds }}</td>
                                                                                                                <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).back.stake }}</td>
                                                                                                                <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).back.pl }}</td>
                                                                                                            </tr>
                                                                                                        </tbody>
                                                                                                    </table>
                                                                                                </div>
                                                                                            </div>
                                                                                        </template>
                                                                                    </template>
                                                                                </template>
                                                                            </div>
                                                                        </template>
                                                                        <template v-else-if="!globalLoader">
                                                                            <NoDataFound />
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="accordion-item">
                                                                <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne1" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne1">
                                                                        {{ $t('unmatched-bets','Unmatched Bets')}}
                                                                    </button>
                                                                </h2>
                                                                <div id="panelsStayOpen-collapseOne1" class="accordion-collapse collapse hide" aria-labelledby="panelsStayOpen-headingOne">
                                                                    <div class="accordion-body">
                                                                        <div class="show-details">
                                                                            <span><i class="fa-solid fa-triangle-exclamation"></i></span>
                                                                            <div class="match-details">
                                                                                <span>{{ $t('no-unmatched-bets','No Unmatched Bets')}}!</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>             
                        </div>
                    </div>
                </div>
                    </div>
            </div>
        </div>
    </section>
</template>
    <template v-else>
        <NoDataFound  v-if="!loading && firstDataFetchDone"/>
    </template>

    <template v-if="eventDetails?.is_exclusive">
        <div class="dScreen fancy_odds fancy-primium-tabs">
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade active show" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
                    <iframe class="fancy-iframe" :src="premiumFancyUrl"></iframe>
                </div>
            </div>
        </div>
    </template>

    <!-- Mobile bet-slip -->
    <template v-if="renderMobileBetSlip">
        <div class="team-bet-details-sec" ref="mobileBetSlip">
            <div id="getMobilePopuplay">
                <div class="mobile-bet-popup">
                    <div class="open-bets-sec" :class="betDetails.selection_type == 'back' ? 'back-betslip-active' : ''"> 
                        <div class="accept-odds-row">                                   
                            <div class="check-mark" v-if="betDetails.bet_type != 'fancy'">
                                <div class="form-check form-switch">
                                    <input  class="form-check-input" @change="changeAcceptOdds()" v-model="betDetails.accept_any_odds" type="checkbox" id="flexSwitchCheckDefaults">
                                    <label  class="form-check-label" for="flexSwitchCheckDefaults">{{ $t('accept-any-odds','Accept any odds')}}</label>
                                </div>
                            </div>
                            <div class="open-bets-head">
                                <p>{{ betDetails.runner_name }}</p>
                            </div>
                        </div>
                        <div class="minmax_text">
                            <p> {{ $t('min-bet','Min Bet')}}: {{betDetails?.min_stake ?? 100}}  &nbsp; {{ $t('max-bet','Max Bet')}}: {{betDetails?.max_stake ?? 2000}} </p>
                        </div>
                        <div class="betslip_stake_field">
                            <div class="stake-field-col">
                                <div class="v-inpt-control">
                                    <div class="number select-stake-inpt">
                                        <button type="button"
                                            :class="betDetails.bet_type != 'market' ? 'd-none' : ''"
                                            @click="oddsMinus">
                                            <i class="fa-solid fa-minus"></i>
                                        </button>
                                        <input type="number" v-model="betDetails.odds" disabled id="odds"
                                            placeholder="odds" />
                                        <label for="text">{{ $t('odds','Odds')}}</label>
                                        <button type="button"
                                            :class="betDetails.bet_type != 'market' ? 'd-none' : ''"
                                            @click="oddsPlus">
                                            <i class="fa-solid fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="stake-field-col">
                                <div class="v-inpt-control stake-inpt-field input-field-stake">
                                    <input v-model="betDetails.stake" @input= "formatStakes" @keypress="checkForStakes($event)" @keyup="calculationOfProfitLoss"
                                        type="tel" id="stake" :placeholder="'Min. ' + betDetails.min_stake + ' ' + ' Max. ' + betDetails.max_stake" ref="stakeInput" class="stake-input" />
                                    <label for="text" class="stake-label-text">{{ $t('stake','Stake')}}</label>
                                </div>
                                <div v-if="stakeRequired" class="guide-text">{{ $t('stake-is-required','Stake is required')}}</div>
                            </div>
                        </div>
                        <div class="stake-grid-box" v-if="chips">
                            <div class="stake-small-box">
                                <button type="button" @click="setStakeValue(chips.chip_val_1)">
                                    +{{ chips.chip_val_1 }}
                                </button>
                                <button type="button"
                                    @click="setStakeValue(chips.chip_val_2 ? chips.chip_val_2 : chips.chip_val_1)">
                                    +{{ chips.chip_val_2 ? chips.chip_val_2 : chips.chip_val_1 }}
                                </button>
                                <button type="button"
                                    @click="setStakeValue(chips.chip_val_3 ? chips.chip_val_3 : chips.chip_val_1)">
                                    +{{ chips.chip_val_3 ? chips.chip_val_3 : chips.chip_val_1 }}
                                </button>
                                <button type="button"
                                    @click="setStakeValue(chips.chip_val_4 ? chips.chip_val_4 : chips.chip_val_1)">
                                    +{{ chips.chip_val_4 ? chips.chip_val_4 : chips.chip_val_1 }}
                                </button>
                                <button type="button"
                                    @click="setStakeValue(chips.chip_val_5 ? chips.chip_val_5 : chips.chip_val_1)">
                                    +{{ chips.chip_val_5 ? chips.chip_val_5 : chips.chip_val_1 }}
                                </button>
                                <button type="button"
                                    @click="setStakeValue(chips.chip_val_6 ? chips.chip_val_6 : chips.chip_val_1)">
                                    +{{ chips.chip_val_6 ? chips.chip_val_6 : chips.chip_val_1 }}
                                </button>
                            </div>
                        </div>

                        <div class="cancails-tabs-btn">
                            <!-- <div class="edit_stake-betslip_btn">
                                <router-link to="/stake-settings">{{ $t('edit-stakes','Edit Stakes')}}</router-link>
                            </div> -->
                            <div class="cancel-btn">
                                <button @click="cancleBetSlip()"
                                    :disabled="betDetails.betLoader">{{ $t('cancel','Cancel')}}</button>
                            </div>
                            <div class="cancel-btn place-bet" v-if="betDetails.stake >= betDetails.min_stake">
                                <button class="btn" :class="betDetails.betLoader ? 'btn-loading' : ''"
                                    @click="saveBets()">
                                    {{ $t('place-bet','Place Bet')}}
                                    <span><b></b><b></b><b></b></span>

                                    <div v-if="!betDetails.betLoader" class="liability-h">{{ betDetails.selection_type == 'lay' ? $t('liability','Liability') : $t('profit','Profit')}}: {{
                                        betDetails.selection_type == 'lay' ? formatNumber(betDetails.pl) :
                                        formatNumber(betDetails.pl) }}</div>
                                    <strong v-if="!betDetails.betLoader" class="timer-zone">{{
                                        betDetails.bet_delay ?  betDetails.bet_delay : 0}}<span>s</span></strong>
                                </button>
                            </div>
                            <div class="cancel-btn disable" v-else>
                                <button>{{ $t('place-bet','Place Bet')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

    <!-- <div class="col-12 col-md-12 col-lg-3 bets-slip">
        <div class="bet-slip-tabs-sec">
            <div class="bet-slip-and-open-bet-tabs">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="pills-betslip-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-betslip" type="button" role="tab"
                            aria-controls="pills-betslip" aria-selected="true">
                            {{ $t('betslip','Betslip')}}
                        </button>
                    </li>
                    <li class="nav-item" role="presentation" v-if="$auth.status">
                        <button @click="getOpenBetsServiceCall()" class="nav-link" id="pills-bets-tab"
                            data-bs-toggle="pill" data-bs-target="#pills-bets" type="button" role="tab"
                            aria-controls="pills-bets" aria-selected="false" tabindex="-1">
                            {{ $t('open-bets','Open Bets')}} 
                        </button>
                    </li>
                </ul>
            </div>
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show" :class="renderDestopBetSlip ? 'active' : ''"
                    v-if="betDetails && renderDestopBetSlip" id="pills-betslip" role="tabpanel"
                    aria-labelledby="pills-betslip-tab">
                    <div class="open-bet-tabs show-now-bets lay-popup" id="lay-pop-up" style="display: block;">
                        <div class="open-bets-sec"
                            :class="betDetails.selection_type == 'back' ? 'back-betslip-active' : ''">
                            <div class="check-mark" v-if="betDetails.bet_type != 'fancy'">
                                <div  class="form-check form-switch accept-ant-odd-title">
                                    <input  class="form-check-input" @change="changeAcceptOdds()" v-model="betDetails.accept_any_odds" type="checkbox" id="flexSwitchCheckDefaults">
                                    <label class="form-check-label" for="flexSwitchCheckDefaults">{{ $t('accept-any-odds','Accept any odds')}}</label>
                                </div>
                            </div>
                            <div class="open-bets-head">
                                <p>{{ betDetails.runner_name }}</p>
                            </div>
                            <div class="row g-1">
                                <div class="col-6">
                                    <div class="v-inpt-control">
                                        <div class="number select-stake-inpt">
                                            <button type="button"
                                                :class="betDetails.bet_type != 'market' ? 'd-none' : ''"
                                                @click="oddsMinus">
                                                <i class="fa-solid fa-minus"></i>
                                            </button>
                                            <input type="number" v-model="betDetails.odds" disabled
                                                :disabled="betDetails.bet_type != 'market'" id="odds"
                                                placeholder="odds" />
                                            <label for="text">{{ $t('odds','Odds')}}</label>
                                            <button type="button"
                                                :class="betDetails.bet_type != 'market' ? 'd-none' : ''"
                                                @click="oddsPlus">
                                                <i class="fa-solid fa-plus"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="v-inpt-control stake-inpt-field">
                                        <input v-model="betDetails.stake" @input= "formatStakes" @keypress="checkForStakes($event)"  @keyup="calculationOfProfitLoss"
                                            type="tel" id="stake" ref="stakeInput" class="stake-input"
                                            :placeholder="'Min. ' + betDetails.min_stake + ' Max. ' + betDetails.max_stake" />
                                        <label for="text" class="stake-label-text">{{ $t('stake','Stake') }}</label>
                                    </div>
                                        <div v-if="stakeRequired" class="guide-text">{{ $t('stake-is-required','Stake is required')}}</div>
                                </div>
                            </div>
                            <div class="stake-info-h">
                                <div class="edit-stake-cmn-btn">
                                    <router-link to="/stake-settings">{{ $t('edit-stakes','Edit Stakes')}}</router-link>
                                </div>
                            </div>
                            <div class="stake-grid-box" v-if="chips">
                                <div class="stake-small-box">
                                    <button type="button" @click="setStakeValue(chips.chip_val_1)">
                                        {{ chips.chip_val_1 }}
                                    </button>
                                    <button type="button"
                                        @click="setStakeValue(chips.chip_val_2 ? chips.chip_val_2 : chips.chip_val_1)">
                                        +{{ chips.chip_val_2 ? chips.chip_val_2 : chips.chip_val_1 }}
                                    </button>
                                    <button type="button"
                                        @click="setStakeValue(chips.chip_val_3 ? chips.chip_val_3 : chips.chip_val_1)">
                                        +{{ chips.chip_val_3 ? chips.chip_val_3 : chips.chip_val_1 }}
                                    </button>
                                    <button type="button"
                                        @click="setStakeValue(chips.chip_val_4 ? chips.chip_val_4 : chips.chip_val_1)">
                                        +{{ chips.chip_val_4 ? chips.chip_val_4 : chips.chip_val_1 }}
                                    </button>
                                    <button type="button"
                                        @click="setStakeValue(chips.chip_val_5 ? chips.chip_val_5 : chips.chip_val_1)">
                                        +{{ chips.chip_val_5 ? chips.chip_val_5 : chips.chip_val_1 }}
                                    </button>
                                    <button type="button"
                                        @click="setStakeValue(chips.chip_val_6 ? chips.chip_val_6 : chips.chip_val_1)">
                                        +{{ chips.chip_val_6 ? chips.chip_val_6 : chips.chip_val_1 }}
                                    </button>
                                </div>
                            </div>
                            <div class="cancails-tabs-btn">
                                <div class="cancel-btn">
                                    <button @click="cancleBetSlip()"
                                        :disabled="betDetails.betLoader">{{ $t('cancel','Cancel')}}</button>
                                </div>
                                <div class="cancel-btn place-bet"
                                    v-if="betDetails.stake >= betDetails.min_stake">
                                    <button class="btn" :class="betDetails.betLoader ? 'btn-loading' : ''"
                                        @click="saveBets()">
                                        {{ $t('place-bet','Place Bet')}}
                                        <span><b></b><b></b><b></b></span>
                                        <div v-if="!betDetails.betLoader" class="liability-h">{{ betDetails.selection_type == 'lay' ? $t('liability','Liability') : $t('profit','Profit')}}: {{
                                            betDetails.selection_type == 'lay' ? formatNumber(betDetails.pl) :
                                            formatNumber(betDetails.pl) }}</div>
                                        <strong v-if="!betDetails.betLoader" class="timer-zone">{{
                                            betDetails.bet_delay }}<span>s</span></strong>
                                    </button>
                                </div>
                                <div class="cancel-btn disable" v-else>
                                    <button>{{ $t('place-bet','Place Bet')}}</button>
                                </div>
                            </div>
                            <div class="bet-confirm-placing" v-if="betDetails.bet_type != 'fancy'">
                                <div class="bet-confirm-text">
                                    <span>{{ $t('confirm-bet-before-placing','Confirm bets before placing')}}</span>
                                </div>
                                <div class="bet-confirm-icon">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox"
                                            id="settingCheckDefaults" @change="changeAcceptOdds()"
                                            v-model="betDetails.accept_any_odds">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="pills-bets" role="tabpanel" aria-labelledby="pills-bets-tab">
                    <div class="show-and-hide-tabs">
                        <div class="accordion open-bets-container" id="accordionPanelsStayOpenExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                                        aria-controls="panelsStayOpen-collapseOne">
                                        {{ $t('unmatched-bets','Unmatched Bets')}}
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse hide"
                                    aria-labelledby="panelsStayOpen-headingOne">
                                    <div class="accordion-body">
                                        <div class="show-details">
                                            <span><i class="fa-solid fa-triangle-exclamation"></i></span>
                                            <div class="match-details">
                                                <span>{{ $t('no-unmatched-bets','No Unmatched Bets')}}!</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="true"
                                        aria-controls="panelsStayOpen-collapseTwo">
                                        {{ $t('matched-bets','Matched Bets')}}
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse show"
                                    aria-labelledby="panelsStayOpen-headingTwo">
                                    <div class="accordion-body controler-body">
                                        <div class="controls-input">
                                            <div class="average-match-h">
                                                <input class="form-check-input" type="checkbox"
                                                    :checked="averageOdds" @change="averageOdds = !averageOdds">
                                                <label>{{ $t('average-odds','Average Odds')}}</label>
                                            </div>
                                        </div>
                                        <div class="table-match-data score-table demo-tabel"
                                            v-for="(event, event_index) in openBetsList" :key="event_index">
                                            <div class="caption font-bold-hide-show"
                                                v-if="event.main_market?.length || event.bookmakers?.length || event.fancies?.length">
                                                {{ event.event_name }}
                                            </div>
                                            <template v-if="!averageOdds">
                                                <template v-if="event?.main_market?.length">
                                                    <h5>{{ $t('main-market','Main Market') }}</h5>
                                                    <template
                                                        v-for="(type, t_index) in (event?.main_market)"
                                                        :key="t_index">
                                                        <div class="match-bookmaker-details"
                                                            :class="type.selection_type == 'back' ? 'back' : 'lay'">
                                                            <span class="text-captiliaze fw-bold"> {{ getBetHeadingForSports(type) }} </span>
                                                            <p>{{ type.selection }}</p>
                                                            <p>{{ $t('placed','Placed')}}
                                                                {{ openBetTimeConverter(type.bet_timestamp_date) }}
                                                            </p>
                                                        </div>
                                                    </template>
                                                </template>
                                                <template v-if="event.bookmakers?.length > 0">
                                                    <div class="match-bookmakker-h">
                                                        <h5>{{ $t('bookmaker','Bookmaker')}} </h5>
                                                    </div>
                                                    <template v-for="(type, t_index) in event?.bookmakers" :key="t_index">
                                                        <div class="match-bookmaker-details"
                                                            :class="type.selection_type == 'back' ? 'back' : 'lay'">
                                                            <span class="text-captiliaze fw-bold"> {{ getBetHeadingForSports(type) }} </span>
                                                            <p>{{ type.selection }}</p>
                                                            <p>{{ $t('placed','Placed')}}
                                                                {{ openBetTimeConverter(type.bet_timestamp_date) }}
                                                            </p>
                                                        </div>
                                                    </template>
                                                </template>
                                                <template v-if="event.fancies?.length > 0">
                                                    <div class="match-bookmakker-h">
                                                        <h5>{{ type?.[0].selection }}</h5>
                                                    </div>
                                                    <template v-for="(type, t_index) in event?.fancies" :key="t_index" >
                                                        <div class="match-bookmaker-details" :class="type.selection_type == 'back' ? 'back' : 'lay'">
                                                            <span class="text-captiliaze fw-bold"> {{ getBetHeadingForSports(type) }} </span>
                                                            <p>{{ type.selection }}</p>
                                                            <p>{{ $t('placed','Placed')}}
                                                                {{ openBetTimeConverter(type.bet_timestamp_date) }}
                                                            </p>
                                                        </div>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-for="(item, index) in getBetandAvgOdds" :key="index">
                                                    <div class="match-bookmakker-h">
                                                        <h5>{{ item.market}} </h5>
                                                    </div>
                                                    <div class="v-data-table">
                                                        <div class="table-responsive">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th class="text-left">{{ $t('selection','Selection')}} </th>
                                                                        <th class="text-left">{{ $t('odds','Odds')}} </th>
                                                                        <th class="text-left">{{ $t('stake','Stake')}}</th>
                                                                        <th class="text-left">{{ $t('profit-liability','Profit/Liability') }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr class="b_data lay">
                                                                        <td class="caption font-weight-bold">{{$t('lay', 'Lay')}}</td>
                                                                        <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).lay.odds }}</td>
                                                                        <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).lay.stake }}</td>
                                                                        <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).lay.pl }}</td>
                                                                    </tr>
                                                                    <tr class="b_data back">
                                                                        <td class="caption font-weight-bold">{{$t('back', 'Back')}}</td>
                                                                        <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).back.odds }}</td>
                                                                        <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).back.stake }}</td>
                                                                        <td class="caption font-weight-bold">{{ getMarketDataByName(item.market).back.pl }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <!-- cashout Modal -->
    <div class="modal fade modal-footer-sticky" id="cashoutModal" tabindex="-1"
        aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h3>{{ $t('cashout','Cashout')}}</h3>
                    <button type="button" class="btn-close" @click="closeCashout()" data-bs-dismiss="modal" aria-label="Close" v-show="!CashoutLoader" ref="closeCashoutModal"></button>
                    <button type="button" class="btn-close" v-show="CashoutLoader"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-banner-sec">
                        <div class="modal-banner-img">
                            <img loading="lazy" src="@/assets/images/cashout-icon.webp" alt="cashout-icon" />
                        </div>
                        <div class="live-but-sub-con text-center mt-3">
                            <span>{{ $t('are-you-sur-want-t-cash-out','Are you sure want to cash out')}}?</span>
                        </div>
                    </div>
                </div>
                <div class="back-thm-modal">
                    <div class="thm-modal-btn w-auto">
                        <button  class="btn btn-secondary cancle-but"
                            data-bs-dismiss="modal" aria-label="Close" @click="closeCashout()" :disabled="CashoutLoader">No</button>
                        <a :disabled="CashoutLoader" class="btn btn-primary place-but" aria-label="Close" @click="callforCashout()">
                            <div v-if="!CashoutLoader">Yes</div>
                            <div v-if="CashoutLoader" class="text-center" id="Otp_loader">
                                <div class="spinner-border" role="status">
                                    <span class="visually-hidden">{{ $t('loading','Loading')}}...</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Fancybook Modal -->
    <div class="modal fade modal-footer-sticky" id="fancyBookModal" tabindex="-1"
        aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h3>{{ $t('fancy-book','Fancy Book')}}</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <table class="table">
                        <thead>
                            <tr class="text-center">
                                <th scope="col">{{ $t('position','Position')}}</th>
                                <th scope="col"></th>
                                <th scope="col">{{ $t('profit-loss','Profit / Loss')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(fancyBookPosition, fBpI) in fancyBookPositions" :key="fBpI">
                                <tr class="table-profit text-center"
                                    :class="isNegative(fancyBookPosition.result) ? 'table-loss' : ''">
                                    <td>{{ fancyBookPosition.odds }}</td>
                                    <td><span class="t-p-l-arrow"><i class="fa-solid fa-arrow-right"></i></span>
                                    </td>
                                    <td>{{ fancyBookPosition.result }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade share-bet-modal" id="shareBetModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered information-modal-wrapper">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>{{ $t('share-bet','Share Bet')}}</h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">                        
                        <div class="shared-modal-wrapper">
                            <div class="shared-bet-wrapper">
                                <figure>
                                    <img :src="output" alt="output">
                                </figure>
                            </div>
                             <div class="v-country-name" v-if="output">
                                <h4>{{capitalizeV(eventDetails.eventName) }}</h4>
                             </div>
                        </div>
                    </div>
                    <div class="modal-footer border-0 feedback-footer">
                        <button class="btn thm-but thm-bor-but feedback-sub-btn share-btn" @click="share()"> 
                            <img loading="lazy" src="@/assets/images/share.webp" alt="share" />
                            {{ $t('share','Share')}}
                        </button>
                        <button class="btn thm-but feedback-close-btn" data-bs-dismiss="modal">{{ $t('close','Close')}}</button>
                    </div>
                </div>
            </div>
    </div>

    <div class="modal bonus-point-modal" id="filterModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog" data-bs-backdrop="static" >
           <div class="modal-dialog  modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5>{{ $t('hide-show-filter','Hide/Show Filter')}}</h5> 
                        <button type="button" class="clear-cmn-btn"  @click="() => { this.selectedPageSections = []; }">{{ $t('clear-all','Clear')}}</button>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="eventDetailFilterModal" @click="() => { this.selectedPageSections = this.eventDetailHideSections; }"></button>
                    </div>
                    <div class="modal-body p-body">
                        <p class="check-blow">{{ $t('hide-show-check-below','Hide/Show Check Below')}} </p>
                        <div class="filter-box">
                            <div class="row">
                                <div class="col-6"  v-for="(pageFilter, pIndex) in pageSections" :key="pIndex">
                                    <div class="filter-btn">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" :value="pageFilter.slug"
                                                    v-model="selectedPageSections" :id="'pageFilter' + pageFilter.slug">
                                            <label class="form-check-label" :for="'pageFilter' + pageFilter.slug">
                                                {{ $t( pageFilter.key, pageFilter.title )}}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-0 balance-low pt-0">
                        <button type="button" class="btn btn-default submit status_btn1 m-auto w-75" data-bs-dismiss="modal"  @click=pageFilterApply()>{{ $t('apply','Apply')}}</button>
                    </div>
                </div>
            </div>
    </div>
    <LowBalanceRemainder />
</template>

<script>
import { Modal } from "bootstrap"
import { mapGetters } from 'vuex';
import * as varConstants from '@/shared/constants/var-constants';
import socketService from "../../../socket/sport-socket-service";
import html2canvas from 'html2canvas';
import { defineAsyncComponent } from 'vue';
import { checkForPremiumFancyEvent } from '@/shared/services/eventLocks'
export default {
    name: 'SportEventDetail',
    components:{
        SportsSideMenu: defineAsyncComponent(() =>
            import('../components/SportsSideMenu.vue')
        ),
        LowBalanceRemainder: defineAsyncComponent(() => 
			import('@/shared/components/modal/LowBalanceRemainder.vue')
		),
        NoDataFound: defineAsyncComponent(() =>
            import('@/shared/components/no-data/NoDataFound.vue')
        )
    },
    data() {
        return {
            event_id: this.$route.params.event_id,
            eventDetails: [],
            upcommingEvents: [],
            matchOddsData: [],
            mainMarketRunners: [],
            bookmakerData: [],
            fancyData: [],
            openBets: {},
            betDetails: {},
            cashOutObject: {},
            marketBookAndExposure: null,
            current_score_tab: 'scoreboard',
            socketIoData: [],
            intervalTimer: null,
            current_bet: {
                stake: '',
                bet_user_guid: '',
                accept_any_odds: false
            },
            renderMobileBetSlip: false,
            renderDestopBetSlip: false,
            screenSize: window.innerWidth,
            mobileView: 991,
            betCloseSetTimeOut: null,
            fancyBookPositions: [],
            chips: this.$store?.getters?.chips,
            showEditStake: false,
            selectedFancyCategory: {
                title: 'All',
                value: 'all'
            },
            fancyCategories: [
                {
                    key:'fancy',
                    title: 'Fancy',
                    value: 'all',
                    order: 1
                },
                {
                    title: 'Premium Fancy',
                    value: 'premiumFancy',
                    key: 'premium-fancy',
                    order: 2,
                    isPremiumAvailable: this.checkForPremiumFancyEvent()
                },
                {
                    key:'line-markets',
                    title: 'Line Markets',
                    value: 'line_markets',
                    fancies: [],
                    order: 3
                },
                {
                    key:'session-markets',
                    title: 'Session Markets',
                    value: 'session_markets',
                    fancies: [],
                    order: 4
                },      
                {
                    key:'over-session-market',
                    title: 'Over Session Market',
                    value: 'over_by_over_session_markets',
                    fancies: [],
                    order: 5
                },
                {
                    key:'ball-by-ball',
                    title: 'Ball By Ball',
                    value: 'ball_by_ball',
                    fancies: [],
                    order: 6
                },
                {
                    key:'fall-of-wicket',
                    title: 'Fall Of Wicket',
                    value: 'fall_of_wicket',
                    fancies: [],
                    order: 7
                },
                {
                    key:'other-markets',
                    title: 'Other Markets',
                    value: 'other_markets',
                    fancies: [],
                    order: 8
                },
                {
                    key:'total-advance',
                    title: 'Total Advance',
                    value: 'total_advance',
                    fancies: [],
                    order: 9
                },
                {
                    key:'meter-markets',
                    title: 'Meter Markets',
                    value: 'meter_markets',
                    fancies: [],
                    order: 10
                },
                {
                    key:'khado-markets',
                    title: 'Khado Markets',
                    value: 'khado_markets',
                    fancies: [],
                    order: 11
                },
                {
                    key:'odd-event-markets',
                    title: 'Odd Event Markets',
                    value: 'odd_even_markets',
                    fancies: [],
                    order: 12
                }
            ],
            premiumFancyUrl: null,
            pinnedFancies: [],
            openBetsList: [],
            showScoreBoard: false,
            showLiveTv: false,
            selectedFancyTab: 'Fancy',
            init: true,
            averageOdds: false,
            cashoutDetails: {},
            CashoutLoader: false,
            eventManage: null,
            cashoutMarketData: {},
            cashoutTimeOut: null,
            stakeRequired:false,
            activeMainTab: 'markets',
            output: null,
            generatedCanvas: null,
            pageNo: 1,
            pageSections: [
                { 'key':'show-full-screen',title:'Show Full Screen', slug: 'show_full_screen' },
                { 'key':'hide-match-odds',title:'Hide Match Odds', slug: 'match_odds' },
                { 'key':'hide-bookmakers',title:'Hide Bookmaker', slug: 'bookmakers' },
                { 'key':'hide-fancy-tabs',title:'Hide Fancy Tab', slug: 'fancy_filters' },
                { 'key':'hide-othermarkets-tabs',title:'Hide Other Markets Tab', slug: 'othermarkets_filters' },
            ],
            selectedPageSections: [],
            inPlay: false,
            cashoutSlipCloseTime: null,
            isPremium: false,
            firstDataFetchDone: false,
            loadingFav: false,
        }
    },
    computed: {
        filteredFancyList() {
            let response = [];
            for (let fancyCat of this.fancyCategories) {
                fancyCat.fancies = [];
            }
            if (this.selectedFancyCategory != null) {
                if (this.selectedFancyCategory?.value == 'all') {
                    if (this.fancyData && this.fancyData.ml) {
                        response = [...this.fancyCategories];
                        for (let fancy of this.fancyData.ml) {
                            let fancyCat = response.find(fc => fc.value == fancy.cat);
                            if (!fancyCat) continue;
                            fancyCat.fancies.push(fancy);
                        }
                    }
                } else {
                    if (this.fancyData && this.fancyData.ml) {
                        this.selectedFancyCategory.fancies = this.fancyData.ml.filter(fc => fc.cat == this.selectedFancyCategory?.value);
                        response = [this.selectedFancyCategory, ...response];
                    }
                }
            }
            return response;
        },
        otherMarkets() {
            let eventMarkets = [];
            if (this.matchOddsData && this.matchOddsData.length) {
                eventMarkets = this.matchOddsData.filter((m) => (m.marketName != 'Match Odds' && m.marketName != 'Who Will Win The Match?')).sort((a, b) => {
                    return a.marketName.localeCompare(b.marketName) // Sort Ascending 
                });
            }
            return eventMarkets;
        },
        formatNumber() {
            return (value) => {
                if (value !== null) {
                    return parseFloat(value).toFixed(2);
                } else {
                    return 0;
                }
            }
        },
        getPinnedFancies() {
            let response = [];
            if (!(this.fancyData && this.fancyData.ml && this.fancyData.ml.length) || !(this.pinnedFancies && this.pinnedFancies.length)) {
                return response;
            }
            response = this.fancyData.ml.filter(f => {
                return this.pinnedFancies.includes(f.mi);
            })
            return response;
        },
        ...mapGetters({
            eventDetailHideSections: 'eventDetailHideSections',
            sportname:'sportname',
            stateUser:'stateUser',
            favouriteGames: 'favouriteGames',
            globalLoader: 'globalLoader'
        }),
        userData(){
            return this.$store.getters.stateUser.userid
        },
        getBetandAvgOdds() {
            if (!this.openBetsList?.length) {
                return [];
            }
            if (this.averageOdds) {
                let averageData = [];

                ['main_market', 'bookmakers', 'fancies'].forEach((item) => {
                    let matchData = {
                        market: item == 'main_market' ? 'Main Market' : item == 'bookmakers' ? 'Bookmaker' : 'Fancy',
                        lay: {
                            odds: 0,
                            stake: 0,
                            pl: 0,
                            betCount: 0
                        },
                        back: {
                            odds: 0,
                            stake: 0,
                            pl: 0,
                            betCount: 0
                        }
                    };
                    let betsList = this.openBetsList[0]
                    if (betsList[item]) {
                        for (let i = 0; i < betsList[item].length; i++) {
                            let currbetType = betsList[item][i];
                            let selectionType = currbetType.selection_type;

                            if (matchData[selectionType]) {
                                matchData[selectionType].odds += parseFloat(currbetType.odds);
                                matchData[selectionType].stake += parseFloat(currbetType.stake);
                                matchData[selectionType].pl += parseFloat(currbetType.pl);
                                matchData[selectionType].betCount++;
                            }
                        }
                    }

                    ['lay', 'back'].forEach(selectionType => {
                        let betType = matchData[selectionType];
                        if (betType.betCount > 0) {
                            betType.odds /= betType.betCount;
                        }

                        betType.odds = parseFloat(betType.odds.toFixed(2));
                        betType.stake = parseFloat(betType.stake.toFixed(2));
                        betType.pl = parseFloat(betType.pl.toFixed(2));
                    });

                    averageData.push(matchData);
                });
                return averageData;
            } else {
                return [
                    ...betsList.main_market,
                    ...betsList.bookmakers,
                    ...betsList.fancies
                ].sort((a, b) => b.bet_timestamp_date - a.bet_timestamp_date);
            }
        },
        getClickBetValue(){
            return this.$store.getters.clickBetValue;
        }
    },
    created() {
        if (this.checkForPremiumFancyEvent) {
            this.fancyCategories;
        };
        this.selectedPageSections = this.eventDetailHideSections;
        let user = this.$auth.user;
        if (user && user.pinnedFancies) {
            this.pinnedFancies = user.pinnedFancies;
        }
        this.getEventDetails()
        this.receiveMessage();
        this.eventManage = this.$store?.getters?.eventManage;
    },
    mounted() {
        
        this.intervalTimer = setInterval(() => {
            this.getEventDetails()
        }, 30000)
        socketService.emit("sub", this.event_id);
        window.addEventListener('resize', this.updateScreenWidth);
        setTimeout(()=>{
            if (this.$auth.status && this.$auth?.user?.balance < 100 && this.$siteSettings?.data?.business_type == 2) {
                this.toggleLowBalanceModal();
                setInterval(()=>{this.toggleLowBalanceModal()}, 600000)
            }
        },2000)
    },
    methods: {
        checkForPremiumFancyEvent,
        changeAcceptOdds() {
            this.current_bet.accept_any_odds = !this.current_bet.accept_any_odds
            let user = this.$store.getters.stateUser;
            if (user.accept_any_odds === undefined) {
                user.accept_any_odds = true;
            } else if (user.accept_any_odds) {
                user.accept_any_odds = false;
            } else {
                user.accept_any_odds = true;
            }
            this.$store.dispatch('setUser', user);
        },
        
        async generateCanvas() {
            if (this.generatedCanvas) {
                return this.generatedCanvas;
            }
            try {
                let el = this.$refs.printMe;
                let canvas = await html2canvas(el);
                this.generatedCanvas = canvas;
                return canvas;
            } catch (error) {
                this.$errorToast('Error generating image. Please try again.');
            }
        },
        
        async print() {
            this.output = null;
            let canvas = await this.generateCanvas();
            if (canvas) {
                this.output = canvas.toDataURL('image/png');
            }
        },

        async share() {
            let canvas = await this.generateCanvas();
            if (!canvas) return;

            try {
                let blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
                let file = new File([blob], 'capture.png', { type: 'image/png' });

                if (navigator.canShare && navigator.canShare({ files: [file] })) {
                    await navigator.share({ files: [file] });
                } else {
                    this.$errorToast('Sharing files is not supported on your device.');
                }
            } catch (error) {
                console.log(error);
                // this.$errorToast('Error sharing image. Please try again.');
            }
        },

        resetCanvas() {
            this.generatedCanvas = null;
            this.print()
        },

        capitalizeV(value) {
            if (!value) return '';
            let parts = value.split(' v ');
            if (parts.length === 2) {
                return `${parts[0]} V ${parts[1]}`;
            }
            return value;
            },
        getEventDetails() {
            if(this.init){
                this.loading = true;
                // this.$store.dispatch('setGlobalLoader', true);
            }
            if(!this.firstDataFetchDone) {
                this.$store.dispatch('setGlobalLoader', true);
            }
            this.$apiCall('get', 'GET_MATCH_DETAILS', null, 'sports', { event_id: this.event_id }).then(response => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader', false);
                if (response) {
                    if (response.status == 200 && response.data.success == true) {
                        this.eventDetails = response.data.data.match
                        this.inPlay = response.data.data.match.inplay == 1 ? false : true;
                        this.upcommingEvents = response.data.data.upcoming
                        this.matchOddsData = response.data.data.match.matchOddData.sort((a, b) => {
                            return a.marketName.localeCompare(b.marketName) // Sort Ascending 
                        });
                        this.bookmakerData = response.data.data.match.bookmakerOddData
                        this.fancyData = response.data.data.match.fancyOddData
                        for (var i = 0; i < this.matchOddsData.length; i++) {
                            for (var j = 0; j < this.matchOddsData[i].runners.length; j++) {
                                for (var k = 0; k < this.matchOddsData[i].runnerName.length; k++) {
                                    if (this.matchOddsData[i].runners[j].sid == this.matchOddsData[i].runnerName[k].SID) {
                                        this.matchOddsData[i].runners[j].runner_name = this.matchOddsData[i].runnerName[k].RN
                                    }
                                }
                            }
                        }

                        // this.fancyData?.ml.sort(function(a, b) {
                        //     return a.mi - b.mi;
                        // });

                        this.socketServiceCall()
                        if (this.favouriteGames?.length && this.favouriteGames?.includes(parseInt(this.eventDetails.eventId))) {
                            this.eventDetails['favourite'] = true
                        } else {
                            this.eventDetails['favourite'] = false
                        }
                        if (this.$auth.status && this.init) {
                            this.getEventExposures();
                            if(this.eventDetails?.is_exclusive && this.checkForPremiumFancyEvent()){
                                this.selectedFancyTab='premiumFancy';
                                this.isPremium = true;
                                this.selectFancyTab('premiumFancy');
                            }else{
                                if (this.eventDetails?.is_exclusive || (this.eventDetails.hasPremiumFancy && !this.eventDetails.hasFancy) && this.checkForPremiumFancyEvent()) {
                                    this.selectedFancyTab='premiumFancy';
                                    this.selectFancyTab('premiumFancy');
                                }else if(this.eventDetails.hasPremiumFancy && this.eventDetails.hasFancy && !this.fancyData?.ml?.length>0 && this.checkForPremiumFancyEvent()){
                                    this.selectedFancyTab='premiumFancy';
                                    let premiumData = {
                                        title: 'Premium Fancy',
                                        value: 'premiumFancy',
                                        key: 'premium-fancy',
                                        order: 2
                                    }
                                    this.selectedFancyCategory = premiumData;
                                    this.changeFancyCategory(premiumData)
                                }
                            }
                        }
                        this.init = false;
                    }
                    this.loading = false;
                    this.$store.dispatch('setGlobalLoader', false);
                    this.firstDataFetchDone = true
                }
            }).catch(error => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.$errorToast(error?.data?.message);
                    setTimeout(()=>{
                        this.$router.push({name: 'Home'});
                        this.$errorToast(this.$t('no-data-found', 'No Data Found'));
                    },1000);
                }
            });
        },
        getRunnerBookHtml(mid, sid, type) {
            if (this.betDetails && this.betDetails.market_id == mid && this.betDetails.runner_books) {
                let runnerBook = this.betDetails.runner_books[sid];
                runnerBook = Math.floor(runnerBook).toFixed(2);
                if (runnerBook >= 0) {
                    return '<div class="positive">» ' + runnerBook + '</div>';
                } else {
                    return '<div class="nagative-value">» -' + ((-1) * runnerBook) + '</div>';
                }     
            } else {
                if (type == 'm' && this.marketBookAndExposure && this.marketBookAndExposure.marketsBook && this.marketBookAndExposure.marketsBook.length) {
                    let marketRunners = this.marketBookAndExposure.marketsBook.find(mB => mB.id == mid);
                    if (marketRunners) {
                        let runnerBook = marketRunners.runner_book.find(mR => mR.selection_id == sid);
                        if (!runnerBook) return '';
                        runnerBook.pl = this.formatNumber(runnerBook.pl);
                        if (runnerBook.pl >= 0) {
                            return runnerBook.pl;
                        } else {
                            return '<div class="nagative-value">-' + ((-1) * runnerBook.pl) + '</div>';
                        }
                    }
                } else if (type == 'b' && this.marketBookAndExposure && this.marketBookAndExposure.bookmakersBook && this.marketBookAndExposure.bookmakersBook.length) {
                    let marketRunners = this.marketBookAndExposure.bookmakersBook.find(mB => mB.id == mid);
                    if (marketRunners) {
                        let runnerBook = marketRunners.runner_book.find(mR => mR.selection_id == sid);
                        if (!runnerBook) return '';
                        runnerBook.pl = this.formatNumber(runnerBook.pl);
                        if (runnerBook.pl >= 0) {
                            return '<div class="positive">' + runnerBook.pl + '</div>';
                        } else {
                            return '<div class="nagative-value">-' + ((-1) * runnerBook.pl) + '</div>';
                        }
                    }
                } else if (type == 'f' && this.marketBookAndExposure && this.marketBookAndExposure.fancyExposures && this.marketBookAndExposure.fancyExposures.length) {
                    let marketRunner = this.marketBookAndExposure.fancyExposures.find(f => f.id == mid);
                    if (!marketRunner) return '';
                    marketRunner.exposures = this.formatNumber(marketRunner.exposures);
                    return ((-1) * marketRunner.exposures);
                } else {
                    return '';
                }
            }
        },
        getEventExposures() {
            this.loading = true;
            this.$apiCall('get', 'GET_EVENT_EXPOSURES', null, 'user', { matchId: this.eventDetails.matchId }).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        this.marketBookAndExposure = response.data.data;
                        this.cashoutMarketData = {};
                        if(this.marketBookAndExposure) {
                            if(this.marketBookAndExposure.marketsBook) {
                                for(let i = 0; i < this.marketBookAndExposure.marketsBook.length; i++) {
                                    if(this.marketBookAndExposure.marketsBook[i].requiredCashout) {
                                        this.cashoutMarketData[this.marketBookAndExposure.marketsBook[i].id] = {type : 'market', value: null}
                                    }
                                }
                            }
                            if(this.marketBookAndExposure.bookmakersBook) {
                                for(let i = 0; i < this.marketBookAndExposure.bookmakersBook.length; i++) {
                                    if(this.marketBookAndExposure.bookmakersBook[i].requiredCashout) {
                                        this.cashoutMarketData[this.marketBookAndExposure.bookmakersBook[i].id] = {type: 'bookmaker', value: null}
                                    }
                                }
                            }
                        }
                        this.callCashout();
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error?.data?.message);
                }
            });
        },
        callCashout() {
            clearTimeout(this.cashoutTimeOut);
            for (let key in this.cashoutMarketData) {
                let currCashout = this.cashoutMarketData[key];
                let currMarket;
                if (currCashout.type == 'market') {
                    currMarket = this.matchOddsData.find(item => item.mid == key);
                    if (!currMarket) continue;
                } else {
                    currMarket = this.bookmakerData.ml.find(item => item.mi == key);
                    if (!currMarket) continue;
                }
                currCashout.value = this.getCashoutValue(currMarket, currCashout.type)
            }
            this.cashoutTimeOut = setTimeout(() => {
                this.callCashout();
            }, 2000);
        },
        selectScoreTab(current_tab) {
            this.current_score_tab = current_tab
        },
        changeFancyCategory(data, openPremiunFancy = false) {
            if(data?.value == 'premiumFancy' || openPremiunFancy){
                 this.isPremium = true;
                 this.getFancyPremiumUrl('premiumFancy');
            }else{
                this.isPremium = false;
                this.selectedFancyCategory = data; 
                this.selectedFancyTab = 'Fancy'
            }
            // this.selectedFancyTab = 'Fancy'
            // this.selectedFancyCategory = data
        },
        getFancyPremiumUrl(category) {
            this.selectedFancyTab = category;
            if (category != 'premiumFancy') return;
            if(this.$auth.status) {
                let { sport_radar_sport_id, sportsradar_id, sportId, eventId } = this.eventDetails;
                let ids = {
                    sportId: sport_radar_sport_id ? `sr:sport:${sport_radar_sport_id}` : sportId,
                    eventId: sportsradar_id && sportsradar_id !== '0' ? `sr:match:${sportsradar_id}` : eventId,
                };
                this.$apiCall('get', 'GET_PREMIUM_FANCY_URL', null, 'user', { sportId: ids.sportId, eventId: ids.eventId }).then(response => {
                    if (response) {
                        if (response.status == 200) {
                            if (response?.data?.status == 0) {
                                this.$errorToast(response.data.debug[0])
                            }
                            else {
                                this.premiumFancyUrl = response.data?.premium_url;
                            }
                        }
                    }
                }).catch(error => {
                    if (error) {
                        this.$errorToast(error[0]);
                    }
                });
            } else {
                this.$errorToast(this.$t('login-access-pre-fancy','Please Log In to access premium fancy!'));
            }
        },
        // changeAcceptOdds() {
        //     this.current_bet.accept_any_odds = !this.current_bet.accept_any_odds
        // },
        setStakeValue(stake, type = null) {
            if (this.betDetails.betLoader) return;
            if (!type) {
                this.betDetails['stake'] = (this.betDetails['stake'] ? this.betDetails['stake'] : 0) + parseFloat(stake);
            } else {
                this.betDetails['stake'] = parseFloat(stake);
            }
            this.maxStakes()
            this.calculationOfProfitLoss();
        },
        pinUnpinFancy(fancy) {
            let user = this.$auth.user
            if (!this.$auth.status || !user) {
                this.$helper.showLogin();
                return
            }
            if (!user.pinnedFancies) {
                user.pinnedFancies = [];
                user.pinnedFancies.push(fancy.mi);
                document.getElementById("pinFancy")?.scrollIntoView({ behavior: "smooth" });
                this.$successToast('Added this fancy under Pin Fancy Market');
            } else {
                if (user.pinnedFancies.includes(fancy.mi)) {
                    user.pinnedFancies.splice(user.pinnedFancies.indexOf(fancy.mi), 1);
                    this.$successToast('Removed from Pin Fancy Market!');
                } else {
                    user.pinnedFancies.push(fancy.mi);
                    this.$successToast('Added this fancy under Pin Fancy Market');
                }
            }
            this.pinnedFancies = user.pinnedFancies;
            this.$store.dispatch('setUser', user);
        },
        oddsMinus() {
            var changeOddsVia = 0;
            if (parseFloat(this.betDetails.odds).toFixed(2) > 1.00 && parseFloat(this.betDetails.odds).toFixed(2) < 2.00) {
                changeOddsVia = 0.01;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 2.00 && parseFloat(this.betDetails.odds).toFixed(2) < 3.00) {
                changeOddsVia = 0.02;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 3.00 && parseFloat(this.betDetails.odds).toFixed(2) < 4.00) {
                changeOddsVia = 0.05;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 4.00 && parseFloat(this.betDetails.odds).toFixed(2) < 6.00) {
                changeOddsVia = 0.10;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 6.00 && parseFloat(this.betDetails.odds).toFixed(2) < 10.00) {
                changeOddsVia = 0.20;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 10.00 && parseFloat(this.betDetails.odds).toFixed(2) < 20.00) {
                changeOddsVia = 0.50;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 20.00 && parseFloat(this.betDetails.odds).toFixed(2) < 30.00) {
                changeOddsVia = 1.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 30.00 && parseFloat(this.betDetails.odds).toFixed(2) < 50.00) {
                changeOddsVia = 2.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 50.00 && parseFloat(this.betDetails.odds).toFixed(2) < 100.00) {
                changeOddsVia = 5.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 100.00) {
                changeOddsVia = 10.00;
            }
            if (this.betDetails.odds > 0) {
                this.betDetails.odds = (parseFloat(this.betDetails.odds) - changeOddsVia).toFixed(2);
                this.calculationOfProfitLoss();
            }
        },
        oddsPlus() {
            var changeOddsVia = 0;
            if (parseFloat(this.betDetails.odds).toFixed(2) > 1.00 && parseFloat(this.betDetails.odds).toFixed(2) < 2.00) {
                changeOddsVia = 0.01;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 2.00 && parseFloat(this.betDetails.odds).toFixed(2) < 3.00) {
                changeOddsVia = 0.02;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 3.00 && parseFloat(this.betDetails.odds).toFixed(2) < 4.00) {
                changeOddsVia = 0.05;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 4.00 && parseFloat(this.betDetails.odds).toFixed(2) < 6.00) {
                changeOddsVia = 0.10;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 6.00 && parseFloat(this.betDetails.odds).toFixed(2) < 10.00) {
                changeOddsVia = 0.20;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 10.00 && parseFloat(this.betDetails.odds).toFixed(2) < 20.00) {
                changeOddsVia = 0.50;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 20.00 && parseFloat(this.betDetails.odds).toFixed(2) < 30.00) {
                changeOddsVia = 1.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 30.00 && parseFloat(this.betDetails.odds).toFixed(2) < 50.00) {
                changeOddsVia = 2.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 50.00 && parseFloat(this.betDetails.odds).toFixed(2) < 100.00) {
                changeOddsVia = 5.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 100.00) {
                changeOddsVia = 10.00;
            }
            if (this.betDetails.odds > 0) {
                this.betDetails.odds = (parseFloat(this.betDetails.odds) + changeOddsVia).toFixed(2);
                this.calculationOfProfitLoss();
            }
        },
        calculationOfProfitLoss() {
            this.betDetails.pl = 0;
            if (this.betDetails.bet_type == 'bookmaker') {
                this.betDetails.pl = ((this.betDetails.odds / 100) * (this.betDetails.stake ?? 0));
            } else if (this.betDetails.bet_type == 'market') {
                this.betDetails.pl = (this.betDetails.odds * (this.betDetails.stake ?? 0)) - (this.betDetails.stake ?? 0);
            } else {
                this.betDetails.pl = ((this.betDetails.stake ?? 0) * this.betDetails.bhav) / 100;
            }
            if (this.betDetails.bet_type == 'fancy') return;
            this.calBookForRunners();
        },
        calBookForRunners() {
            this.betDetails.runner_books = {};
            let marketRunners = [];
            if (this.betDetails.bet_type == 'market') {
                if (this.marketBookAndExposure && this.marketBookAndExposure.marketsBook && this.marketBookAndExposure.marketsBook.length) {
                    marketRunners = this.marketBookAndExposure.marketsBook.find(mB => mB.id == this.betDetails.market_id);
                    if (!marketRunners) {
                        marketRunners = this.betDetails.market.runners;
                    } else {
                        marketRunners = marketRunners.runner_book;
                    }
                } else {
                    marketRunners = this.betDetails.market.runners;
                }
                for (let mRunner of marketRunners) {
                    this.betDetails.runner_books[mRunner.sid ? mRunner.sid : mRunner.selection_id] = mRunner.pl ? mRunner.pl : 0;
                }
            } else if (this.betDetails.bet_type == 'bookmaker') {
                if (this.marketBookAndExposure && this.marketBookAndExposure.bookmakersBook && this.marketBookAndExposure.bookmakersBook.length) {
                    marketRunners = this.marketBookAndExposure.bookmakersBook.find(mB => mB.id == this.betDetails.market_id);
                    if (!marketRunners) {
                        marketRunners = this.betDetails.market.sl;
                    } else {
                        marketRunners = marketRunners.runner_book;
                    }
                } else {
                    marketRunners = this.betDetails.market.sl;
                }
                for (let mRunner of marketRunners) {
                    this.betDetails.runner_books[mRunner.si ? mRunner.si : mRunner.selection_id] = mRunner.pl ? mRunner.pl : 0;
                }
            }
            // runner book is not exist
            for (var selection_id of Object.keys(this.betDetails.runner_books)) {
                this.betDetails.runner_books[selection_id] = parseFloat(this.betDetails.runner_books[selection_id]);
                if (this.betDetails.runner_selection_id == selection_id) {
                    if (this.betDetails.selection_type == 'back') {
                        this.betDetails.runner_books[selection_id] += parseFloat(this.betDetails.pl);
                    } else {
                        this.betDetails.runner_books[selection_id] -= parseFloat(this.betDetails.pl);
                    }
                } else {
                    if (this.betDetails.selection_type == 'back') {
                        this.betDetails.runner_books[selection_id] -= parseFloat(this.betDetails.stake ?? 0);
                    } else {
                        this.betDetails.runner_books[selection_id] += parseFloat(this.betDetails.stake ?? 0);
                    }
                }
            }
        },
        addBet(market, runner, selection_type, bet_type, r_index, event) {
            if (this.betDetails && this.betDetails.betLoader) return;
            if (!this.$auth.status) {
                this.$errorToast('Please login to place the bets');
                return
            } else {
                this.stakeRequired = false;
                let user = this.$store.getters.stateUser;
                if (!market || ((bet_type == 'market' || bet_type == 'bookmaker') && !runner) ||
                    (bet_type == 'market' && ((market && market.st != 'OPEN') || (runner && runner.s != 'ACTIVE'))) ||
                    (bet_type == 'bookmaker' && ((market && market.sn != 'ONLINE') || (runner && runner.ss != 'ACTIVE')))
                    || (bet_type == 'fancy' && market.sn != 'ONLINE')) {
                    this.$errorToast('Market is not active!');
                    return
                }
                this.setBetslipCount(market, bet_type);
                this.betDetails = {};
                this.betDetails['match_id'] = this.eventDetails.matchId;
                this.betDetails['min_stake'] = (bet_type == 'fancy' || bet_type == 'bookmaker') ? market.mins : (market.min_stake_limit ? market.min_stake_limit : 100);
                this.betDetails['max_stake'] = (bet_type == 'fancy' || bet_type == 'bookmaker') ? market.ms : (market.stake_limit ? market.stake_limit : 2000);
                this.betDetails['sport_id'] = this.eventDetails.sportId;
                this.betDetails['eventId'] = this.eventDetails.eventId;
                this.betDetails['selection_type'] = selection_type;
                this.betDetails['bet_type'] = bet_type;
                this.betDetails['bet_delay'] = (bet_type == 'fancy' || bet_type == 'bookmaker') ? (market.bd || 0) : (market.bet_delay || 0);
                this.betDetails['market'] = market;
                this.betDetails['accept_any_odds'] = user.accept_any_odds === undefined ? false : user?.accept_any_odds;
                this.betDetails['runner'] = runner;
                this.betDetails['rIndex'] = r_index;
                this.betDetails['bet_time'] = Math.round(Date.now() / 1000);
                if (this.betDetails.bet_type == 'market') {
                    this.betDetails['market_id'] = market.mid;
                    this.betDetails['bet_delay'] = market.bet_delay;
                    this.betDetails['runner_name'] = runner.runner_name;
                    this.betDetails['runner_selection_id'] = runner.sid;
                    this.betDetails['odds'] = (runner.ex && runner.ex[selection_type == 'back' ? 'b' : 'l'] && runner.ex[selection_type == 'back' ? 'b' : 'l'][0]) ? runner.ex[selection_type == 'back' ? 'b' : 'l'][0].p : '';
                    this.betDetails['screen_odds'] = (runner.ex && runner.ex[selection_type == 'back' ? 'b' : 'l'] && runner.ex[selection_type == 'back' ? 'b' : 'l'][0]) ? runner.ex[selection_type == 'back' ? 'b' : 'l'][0].p : '';
                } else if (this.betDetails.bet_type == 'bookmaker') {
                    this.betDetails['market_id'] = market.mi;
                    this.betDetails['bet_delay'] = market.bd;
                    this.betDetails['runner_name'] = runner.sln;
                    this.betDetails['runner_selection_id'] = runner.si;
                    this.betDetails['odds'] = runner[selection_type == 'back' ? 'b' : 'l'];
                    this.betDetails['screen_odds'] = runner[selection_type == 'back' ? 'b' : 'l'];
                } else {
                    this.betDetails['runner_name'] = market.mn;
                    this.betDetails['market_id'] = market.mi;
                    this.betDetails['bet_delay'] = market.bd;
                    this.betDetails['runner_selection_id'] = market.mi;
                    this.betDetails['fancy_data'] = 1;
                    this.betDetails['odds'] = market[selection_type == 'back' ? 'ry' : 'rn'];
                    this.betDetails['screen_odds'] = market[selection_type == 'back' ? 'ry' : 'rn'];
                    this.betDetails['bhav'] = market.cat == 'line_markets' ? 100 : market[selection_type == 'back' ? 'oy' : 'on']
                }
                if (this.$store.getters.getactiveClickbet) {
                    for (var i = 0; i < this.getClickBetValue?.length; i++) {
                        if (this.getClickBetValue[i].isSelected) {
                            this.betDetails.stake = this.getClickBetValue[i].value;
                            this.showBetSlip(market, runner, bet_type, event);
                            this.calculationOfProfitLoss();
                            this.saveBets();
                        }
                    }
                } else {
                    this.showBetSlip(market, runner, bet_type, event);
                }

            }
        },
        setBetslipCount(market, bet_type) {
            let user = { ...this.$store.getters.stateUser };
            let betslipCount = { ...(user.betslipCount && user.betslipCount.eventId == this.event_id ? user.betslipCount : { eventId: this.event_id }) };

            let betSlipObject = {
                exp: Math.round(Date.now() / 1000) + 180 // 180 seconds for 3 minutes
            };

            if (bet_type === 'market') {
                betslipCount[market.mid] = betslipCount[market.mid] || [];
                betslipCount[market.mid].push(betSlipObject);
            } else if (bet_type === 'bookmaker' || bet_type === 'fancy') {
                betslipCount[market.mi] = betslipCount[market.mi] || [];
                betslipCount[market.mi].push(betSlipObject);
            }
            this.$store.dispatch('setUser', { ...user, betslipCount });
        },
        counterStartForCloseBet() {
            clearInterval(this.betCloseSetTimeOut);
            this.betCloseSetTimeOut = setInterval(() => {
                var current_time = Math.round(Date.now() / 1000);
                if (current_time - this.betDetails.bet_time > 9) {
                    this.cancleBetSlip();
                }
            }, 1000);
        },
        clearStake() {
            this.betDetails['stake'] = 0;
            this.calculationOfProfitLoss();
        },
        cancleBetSlip() {
            this.betDetails = {};
            clearInterval(this.betCloseSetTimeOut);
            // close cashout modal
            // this.$refs.closeCashoutModal.click();
            this.renderMobileBetSlip = false
            this.renderDestopBetSlip = false
        },
        showBetSlip(market, runner, bet_type, event) {
            let mid = '';
            let rsid = '';
            if (bet_type == 'fancy') {
                mid = rsid = market.mi;
                rsid = market.mi;
            } else {
                mid = market.mid ? market.mid : (market.mi ? market.mi : 0);
                rsid = runner ? (runner.sid ? runner.sid : (runner.si ? runner.si : 0)) : 0
            }
            if (this.screenSize <= this.mobileView) {
                this.renderMobileBetSlip = true

                this.$nextTick().then(() => {
                    const betSlipElement = this.$refs.mobileBetSlip
                    if (betSlipElement) {
                        event.target.closest('.bet-slip-area').appendChild(betSlipElement);
                    }
                    this.$refs.stakeInput?.focus();
                });
            } else {
                // this.renderDestopBetSlip = true
                // document.body.scrollTop = 0;
                // document.documentElement.scrollTop = 0;
                this.renderMobileBetSlip = true

                this.$nextTick().then(() => {
                    const betSlipElement = this.$refs.mobileBetSlip
                    if (betSlipElement) {
                        event.target.closest('.bet-slip-area').appendChild(betSlipElement);
                    }
                    this.$refs.stakeInput?.focus();
                });
            }
            this.counterStartForCloseBet();

        },
        openBetTimeConverter(timestamp) {
           return this.$dateTime.convertUnixDate(timestamp, 'DD/MM/YYYY hh:mm A')
        },
        gotoEvent(event_id) {
            this.event_id = event_id
            this.getEventDetails()
        },
        makeFavourite(event) {
            if (!this.$auth.status) {
                this.$errorToast('Please login first!');
                return
            }
            this.loadingFav = true;
            let data = {
                "match_id": event.eventId,
                "game_type": 0,
            };
            this.$apiCall('post','MAKE_FAVOURITE',data).then(response => {
                this.loadingFav = false;
                if (response) {
                    if (response.status == 200) {
                        event.favourite = !event.favourite;
                        this.$successToast(response.data.message);
                        const eventArray = this.$store.getters.favouriteGames;
                        if(!eventArray.includes(+event.eventId)){
                            eventArray.push(+event.eventId);
                            this.$store.dispatch('setFavouriteGames', eventArray)
                        } else{
                            const filtered = eventArray.filter(eve => eve != +event.eventId);
                            this.$store.dispatch('setFavouriteGames',filtered)
                        }
                    }
                }
            }).catch(error => {
                this.loadingFav = false;
                if (error) {
                    this.$errorToast(error?.data?.message);
                }
            });
        },
        async saveBets() {
            if (!this.betDetails.stake || !this.betDetails.odds) {
                this.$errorToast('Stake field is required!');
                return;
            }
            if (!this.betDetails.accept_any_odds) {
                this.betDetails.accept_any_odds = 0;
            }
            if (this.betDetails.betLoader) {
                return;
            }
            let user = this.$store.getters.stateUser;
            
            let slipCount = user.betslipCount[this.betDetails.market_id];
            let currTime =  Math.round(Date.now() / 1000);
            for(let i = 0; i<slipCount.length; i++) {
                if(slipCount[i].exp < currTime) {
                    slipCount.splice(i, 1)
                }
            }
            if(slipCount.length > 2) {
                this.betDetails.slip_count = slipCount.length;
            }
            this.betDetails.bet_user_guid = Math.random().toString(36);
            this.betDetails.betLoader = true;
            clearInterval(this.betCloseSetTimeOut);
            let data = this.getBetDetails();
            this.$apiCall('post', 'PLACE_ORDER', data).then(response => {
                if (response) {
                    if (response.status == 200) {
                        if (this.betDetails.bet_type == 'market') {
                            if (this.marketBookAndExposure && this.marketBookAndExposure.marketsBook && this.marketBookAndExposure.marketsBook.length) {
                                let marketBook = this.marketBookAndExposure.marketsBook.find(m => m.id == this.betDetails.market_id);
                                if (!marketBook) {
                                    this.marketBookAndExposure.marketsBook.push({ id: this.betDetails.market_id, runner_book: response.data.data.runner_book })
                                } else {
                                    marketBook.runner_book = response.data.data.runner_book;
                                }
                            } else {
                                this.marketBookAndExposure = {
                                    marketsBook: [{ id: this.betDetails.market_id, runner_book: response.data.data.runner_book }]
                                };
                            }
                        } else if (this.betDetails.bet_type == 'bookmaker') {
                            if (this.marketBookAndExposure && this.marketBookAndExposure.bookmakersBook && this.marketBookAndExposure.bookmakersBook.length) {
                                let marketBook = this.marketBookAndExposure.bookmakersBook.find(m => m.id == this.betDetails.market_id);
                                if (!marketBook) {
                                    this.marketBookAndExposure.bookmakersBook.push({ id: this.betDetails.market_id, runner_book: response.data.data.runner_book })
                                } else {
                                    marketBook.runner_book = response.data.data.runner_book;
                                }
                            } else {
                                this.marketBookAndExposure = {
                                    bookmakersBook: [{ id: this.betDetails.market_id, runner_book: response.data.data.runner_book }]
                                };
                            }
                        } else {
                            if (!(this.marketBookAndExposure && this.marketBookAndExposure.fancyExposures && this.marketBookAndExposure.fancyExposures.length)) {
                                this.marketBookAndExposure.fancyExposures = [];
                            }
                            if (this.marketBookAndExposure && this.marketBookAndExposure.fancyExposures && this.marketBookAndExposure.fancyExposures.length) {
                                let fancyExpoIndex = this.marketBookAndExposure.fancyExposures.findIndex(f => f.id == this.betDetails.market_id);
                                if (fancyExpoIndex >= 0) {
                                    this.marketBookAndExposure.fancyExposures[fancyExpoIndex].exposures = response.data.data.exposure;
                                } else {
                                    this.marketBookAndExposure.fancyExposures.push({ id: this.betDetails.market_id, exposures: response.data.data.exposure });
                                }
                            }
                        }
                        user.exposure = response.data.data.total_exposure;
                        user.betslipCount[this.betDetails.market_id] = [];
                        this.$store.dispatch('setUser', user);
                        this.getEventExposures();
                        this.cancleBetSlip()
                        this.$successToast(response.data.message);
                    } else {
                        this.betDetails.bet_time = Math.round(Date.now() / 1000);
                        this.counterStartForCloseBet();
                        this.betDetails.betLoader = false;
                        this.$errorToast(response.data.message);
                    }
                }
            }).catch(error => {
                this.betDetails.betLoader = false;
                if (error) {
                    this.betDetails.bet_time = Math.round(Date.now() / 1000);
                    this.counterStartForCloseBet();
                    this.$errorToast(error?.[0]);
                }
            });
        },
        getBetDetails() {
            return {
                "runner_name": this.betDetails['runner_name'],
                "odds": this.betDetails['odds'],
                "market_id": this.betDetails['market_id'].toString(),
                "runner_selection_id": this.betDetails['runner_selection_id'],
                "match_id": this.betDetails['match_id'],
                "selection_type": this.betDetails['selection_type'],
                "bet_type": this.betDetails['bet_type'],
                "eventId": this.betDetails['eventId'],
                "rIndex": this.betDetails['rIndex'],
                "bet_user_guid": this.betDetails.bet_user_guid,
                "sport_id": this.betDetails['sport_id'],
                "min_stake": this.betDetails['min_stake'],
                "max_stake": this.betDetails['max_stake'],
                "accept_any_odds": this.betDetails['accept_any_odds'],
                "stake": this.betDetails['stake'],
                "validate": 0,
                "bhav": this.betDetails['bhav'],
                "betId": this.$dateTime.currentTimestamp(),
                "slip_count": this.betDetails['slip_count'],
                "userid": this.stateUser.userid,
                "bet_delay": this.betDetails['bet_delay'],
                "screen_odds": this.betDetails['screen_odds']
            }
        },
        socketServiceCall() {
            socketService.on("App\\\\Events\\\\SportsBroadcastData", (mainMarketOdds) => {
                if (mainMarketOdds && mainMarketOdds.length) {
                    for (let mRunner of mainMarketOdds) {
                        let mOddsData = this.matchOddsData.find(m => m.mid == mRunner.mid);
                        if (!mOddsData || (mRunner && !mRunner.runners.length)) continue;
                        for (let runner of mRunner.runners) {
                            let mOddsDataRuuner = mOddsData.runners.find(r => r.sid == runner.sid);
                            if (!mOddsDataRuuner || (runner && !runner.ex)) continue;
                            // back available 
                            if (runner.ex.b) {
                                mOddsDataRuuner.ex.b = runner.ex.b;
                            }
                            // lay available
                            if (runner.ex.l) {
                                mOddsDataRuuner.ex.l = runner.ex.l;
                            }
                        }
                    }
                }
            });
            socketService.on("App\\\\Events\\\\BroadcastBookmaker", (bookmakerOdds) => {
                if (bookmakerOdds && bookmakerOdds.length) {
                    let ml = bookmakerOdds[0].ml
                    if (!ml || (ml && !ml.updated)) return;
                    // process updated data
                    let updatedList = ml.updated;
                    if (updatedList && updatedList.length) {
                        for (let market of updatedList) {
                            let bData = this.bookmakerData.ml.find(b => b.mi == market.mi);
                            if (!bData) continue;
                            let marketKeys = Object.keys(market);
                            for (let mKey of marketKeys) {
                                if (mKey == 'mi') {
                                    continue;
                                } else if (mKey == 'sl') {
                                    for (let selection of market.sl) {
                                        let bDataSelection = bData.sl.find(s => s.si == selection.si);
                                        if (!bDataSelection) continue;
                                        let selectionKeys = Object.keys(selection);
                                        for (let sKey of selectionKeys) {
                                            bDataSelection[sKey] = selection[sKey];
                                        }
                                    }
                                } else {
                                    bData[mKey] = market[mKey];
                                }
                            }
                        }
                    }
                }
            });
            socketService.on("App\\\\Events\\\\BroadcastFancy", (fancyOdds) => {
                if (fancyOdds && fancyOdds.length) {
                    let ml = fancyOdds[0].ml
                    if (!ml || ((ml && !ml.updated) && (ml && !ml.added) && (ml && !ml.deleted))) return;
                    // process updated data
                    let updatedList = ml.updated;
                    let addedList = ml.added;
                    let deletedList = ml.deleted;
                    // remove deleted fancies
                    if (deletedList && deletedList.length) {
                        this.fancyData.ml = this.fancyData.ml.filter(function (m) {
                            return !deletedList.includes(m.mi)
                        });
                    }
                    // update updated fancies
                    if (updatedList && updatedList.length) {
                        for (let market of updatedList) {
                            let fData = this.fancyData.ml.find(f => f.mi == market.mi);
                            if (!fData) continue;
                            let marketKeys = Object.keys(market);
                            for (let mKey of marketKeys) {
                                if (mKey == 'mi') {
                                    continue;
                                } else {
                                    fData[mKey] = market[mKey];
                                }
                            }
                        }
                    }
                    // merged with old fancies array
                    if (addedList && addedList.length) {
                        for(let i = 0; i< addedList.length; i++) {
                            let checkExistingFancy = this.fancyData.ml.find(fD => fD.mi == addedList[i].mi)
                            if(!checkExistingFancy) {
                                this.fancyData.ml = [...this.fancyData.ml, addedList[i]]
                            }
                        }
                    }
                }
            });
        },
        receiveMessage() {
            window.addEventListener('message', event => {
                var iframe = document.getElementById('sportradar_score');
                if (iframe != null && event.data.height != 0) {
                    iframe.style.height = event.data.height + 'px';
                }
            });
        },
        checkForStakes(event) {
            if (event.key.toLowerCase() === 'e') {
                event.preventDefault();
            }
            if (event.key === '-' || event.key === '+' || event.key === '.') {
                event.preventDefault();
            }
        },
        formatStakes() {
            let stringValue = this.betDetails.stake.toString().replace(/[^0-9]/g, '');
            this.betDetails.stake = stringValue === '' ? null : parseInt(stringValue);
            this.stakeRequired = this.betDetails.stake === null;
            this.maxStakes()
        },
        maxStakes(){
            var value = this.betDetails.stake
            if (value !== '' && parseInt(value) > this.betDetails.max_stake) {
                this.betDetails.stake = this.betDetails.max_stake;
            }
        },    
        getfancyBook(fancy_id) {
            if (!this.$auth.status) {
                return;
            }
            if (!(this.marketBookAndExposure && this.marketBookAndExposure.fancyExposures && this.marketBookAndExposure.fancyExposures.length)) {
                return;
            }
            let fancyExpoIndex = this.marketBookAndExposure.fancyExposures.findIndex(f => f.id == fancy_id);
            if (fancyExpoIndex < 0) return;
            this.$apiCall('post', 'GET_FANCY_BOOK', { id: fancy_id, match_id: this.eventDetails.matchId, fancy_market_id: 1 }).then(response => {
                if (response.status == 200 && response.data && response.data.data.book) {
                    this.fancyBookPositions = response.data.data.book;
                    let fancyBookModal = new Modal('#fancyBookModal');
                    fancyBookModal.show();
                } else {
                    this.$errorToast(response?.data?.message);
                }
            }).catch(error => {
                if (error) {
                    this.$errorToast(error?.data?.message);
                }
            });
        },
        getOpenBetsServiceCall() {
            if (!this.$auth.status) {
                return
            }
            this.$store.dispatch('setGlobalLoader', true);
            let data = {
                "type": 'sport',
                "sub_type": this.eventDetails.sportId,
                "status": 'open',
                "page_entries": this.pageEntries,
                "from": this.$dateTime.getDateSaperatedByDays(15),
                "to":this.$dateTime.getcurrentDate()
            }
            this.$apiCall('post', 'OPEN_BETS_EVENT_LISTING', data, 'user', { page: this.pageNo }).then(response => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader', false);
                this.openBetsList = [];
                this.totalPage = 0;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response?.data?.debug[0]);
                        } else {
                            this.serviceData = response?.data?.data;
                            this.totalPage = this.serviceData?.last_page;
                            this.openBetsList = response?.data?.data?.data;
                                this.openBetsList = this.openBetsList.filter((dataList) => {
                                    return dataList.event_id == this.event_id;
                                });
                        }
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        selectFancyTab(category) {
            this.selectedFancyTab = category;
            if(this.selectedFancyTab == 'Fancy'){
                this.selectedFancyCategory = {
                    key:'fancy',
                    title: 'Fancy',
                    value: 'all',
                    order: 1
                }
            }
            if (category != 'premiumFancy') return;
            if(this.$auth.status) {
                let { sport_radar_sport_id, sportsradar_id, sportId, eventId } = this.eventDetails;
                let ids = {
                    sportId: sport_radar_sport_id ? `sr:sport:${sport_radar_sport_id}` : sportId,
                    eventId: sportsradar_id && sportsradar_id !== '0' ? `sr:match:${sportsradar_id}` : eventId,
                };
                this.$apiCall('get', 'GET_PREMIUM_FANCY_URL', null, 'user', { sportId: ids.sportId, eventId: ids.eventId }).then(response => {
                    this.premiumFancyUrl = response.data.premium_url;
                }).catch(error => {
                    if (error) {
                        this.$errorToast(error.data.message);
                    }
                });
            } else {
                this.$errorToast(this.$t('login-access-pre-fancy','Please Log In to access premium fancy!'));
            }
        },
         updateEventDetails(value) {
            this.$router.push({ name: 'sports-event-detail', params: { event_id: value.event_id } });

        },
        isNegative(num) {
            if (Math.sign(num) === -1) {
                return true;
            }
            return false;
        },
        getAverageOdds(data) {
            var averageOdds = 0
            for (var i = 0; i < data.length; i++) {
                data[i].odds = parseFloat(data[i].odds)
                averageOdds += (data[i].odds) / data.length
            }
            return averageOdds.toFixed(2);
        },
        getAverageStake(data) {
            var averageStake = 0
            for (var i = 0; i < data.length; i++) {
                data[i].stake = parseFloat(data[i].stake)
                averageStake += (data[i].stake) / data.length
            }
            return Math.round(averageStake);
        },
        getAveragePL(data) {
            var averagePL = 0
            for (var i = 0; i < data.length; i++) {
                data[i].pl = parseFloat(data[i].pl)
                averagePL += (data[i].pl) / data.length
            }
            return Math.round(averagePL);
        },
        getKFormatter(num) {
            return this.$helper.kFormatter(num)
        },
        calculateCashoutStake(book) {
            try {
                if (book) {
                    let stats = [];
                    for (let i = 0; i < book.length; i++) {
                        const e = book[i];
                        const bet_type = e.pl < 0 ? 1 : -1; // 1 is lay -1 is back
                        const rev_bet_odds = bet_type == -1 ? (e.back_odds - 1) : (e.lay_odds - 1);
                        const bet_odds = bet_type == 1 ? (e.back_odds - 1) : (e.lay_odds - 1);
                        const real_bet_odds = bet_type == 1 ? (e.back_odds) : (e.lay_odds);
                        const rev_bet = (e.pl * -bet_type) / rev_bet_odds;
                        stats.push({ ...e, bet_type, bet_odds, rev_bet_odds, rev_bet, real_bet_odds });
                    };
                    stats = stats.sort((a, b) => Math.abs(a.rev_bet) - Math.abs(b.rev_bet));
                    const [bet1, stake1] = this.findBetFromBook(stats[1].bet_type, stats[1].bet_odds, stats[1].pl, stats[0].pl);
                    stats[1].bet = Math.abs(bet1);
                    if (stats[2]) {
                        const newStake = stats[2].pl - (stats[1].bet * stats[1].bet_type)
                        const [bet2, stake2] = this.findBetFromBook(stats[2].bet_type, stats[2].bet_odds, newStake, stake1);
                        stats[2].bet = Math.abs(bet2);
                        stats = stats.map(e => ({ ...e, finalStake: stake2 }));
                        if (bet1 != 0) {
                            return [stats[1], stats[2]];
                        } else {
                            return [stats[2]];
                        }
                    }
                    stats = stats.map(e => ({ ...e, finalStake: stake1 }));
                    return [stats[1]];
                }
            } catch (e) {
                // console.log('=====', e)
            }
        },
        // Book 1 will be the one on which the bet would be done. Book 2 is for matching the ref
        findBetFromBook(bet_type, odds, stake1, stake2) {
            switch (bet_type) {
                case 1: //Lay
                    let [betRev, stakeRev] = this.findBet(odds, stake1, stake2);
                    let bet = betRev / odds;
                    let stake = parseFloat(stake1) + parseFloat(betRev);

                    return [bet, stake];
                case -1: //Back
                    return this.findBet(odds, stake1, stake2);
                default:
                    return [0, 0]
            }
        },
        findBet(odd1, s1, s2) {
            try {
                if (s1 == s2) return [0, s1];

                let a1 = s1 > 0 ? odd1 : 1 / odd1, c1 = -s1;
                let a2 = -1, c2 = -s2;

                a2 -= a1;
                c2 -= c1;

                let bet = c2 / a2;
                let newStake = (-a1 * bet + c1);

                return [bet, -newStake];
            } catch (e) {
                // console.log('===', e)
            }
        },
        calculateCashoutStakeForBookmaker(bookData) {
            if(bookData.book) {

                let runners = bookData.book.sort((a, b) => a.pl - b.pl)

                let r1 = runners[0];
                let r2 = runners[1];
                r1.pl = parseFloat(r1.pl).toFixed(2)
                r2.pl = parseFloat(r2.pl).toFixed(2)
                
                let betType;
                let betStake;
                let cashoutStake;
                let betOdds;

                if(bookData.unavailableRunners == 1) {
                    if(r1.ss == 'SUSPEND') {
                        betType = 1; //lay
                        betOdds = r2.lay_odds
                    } else {
                        betType = -1; //back
                        betOdds = r1.back_odds
                    }
                } else if(!bookData.unavailableRunners) {
                    betType = -1; //back
                    betOdds = r1.back_odds
                } else {
                    return null
                }

                if(betType == 1) {
                    betStake = (r2.pl - r1.pl)/(betOdds);
                    cashoutStake = {
                        run1 : parseFloat(r1.pl)+betStake,
                        run2 : parseFloat(r2.pl)+(-1*(((betOdds-1)*100)*betStake)/100)
                    }
                } else if(betType == -1) {
                    betStake = (r2.pl - r1.pl)/(betOdds);
                    cashoutStake = {
                        run1 : parseFloat(r1.pl)+(((betStake)*((betOdds-1)*100))/100),
                        run2 : parseFloat(r2.pl)-betStake
                    }
                }
                let real_bet_odds = (betOdds - 1) * 100;
                return ([{...r1, betOdds, betType, betStake, cashoutStake, real_bet_odds}]);
            }
        },
        calculateAlternateCashoutStake(book) {
            let runners = book.sort((a, b) => b.pl - a.pl)

            let r1 = runners[0];
            let r2 = runners[1];

            let betType = -1; //always back
            let betStake;
            let cashoutStake;
            let betOdds;

            betOdds = r2.back_odds

            betStake = (r1.pl-r2.pl)/(betOdds);
            cashoutStake = {
                run1 : parseFloat(r1.pl)-betStake,
                run2 : parseFloat(r2.pl) + (r2.back_odds*betStake)-betStake
            }
            let real_bet_odds = betOdds;
            return ([{...r2, betOdds, betType, betStake, cashoutStake, real_bet_odds}]);
        },
        getBook(market, type) {
            let runners = null;
            try {
                if (type == 'market') {
                    if (this.marketBookAndExposure && this.marketBookAndExposure.marketsBook && this.marketBookAndExposure.marketsBook.length) {
                        let marketBook = this.marketBookAndExposure.marketsBook.find(m => m.id == market.mid)?.runner_book;
                        marketBook = Object.create(marketBook);
                        if (!marketBook) {
                            return null
                        } else if(market.marketName == 'Who Will Win The Match?') {

                            for (let i = 0; i < marketBook.length; i++) {

                                for (let j = 0; j < market.runners.length; j++) {
                                    if (marketBook[i].selection_id == market.runners[j].sid) {
                                        marketBook[i] = {
                                            ...marketBook[i],
                                            back_odds: market.runners[j].ex.b?.[0]?.p,
                                            lay_odds: 0,
                                            sid: market.runners[j].sid,
                                            s: market.runners[j].s
                                        }
                                    }
                                }
                            }
                            return this.calculateAlternateCashoutStake(marketBook);

                        }else {
                            let cashoutUnavailableFlag = false;
                            for (let i = 0; i < marketBook.length; i++) {

                                for (let j = 0; j < market.runners.length; j++) {
                                    if (marketBook[i].selection_id == market.runners[j].sid) {
                                        marketBook[i] = {
                                            ...marketBook[i],
                                            back_odds: market.runners[j].ex.b?.[0]?.p,
                                            lay_odds: market.runners[j].ex.l?.[0]?.p,
                                            sid: market.runners[j].sid,
                                            s: market.runners[j].s
                                        }
                                        if (!cashoutUnavailableFlag && (!marketBook[i].back_odds || !marketBook[i].lay_odds || market.runners[j].s != 'ACTIVE')) {
                                            cashoutUnavailableFlag = true;
                                        }
                                    }
                                }
                            }
                            if (cashoutUnavailableFlag) {
                                return null
                            }
                            runners = marketBook
                        }
                    }
                } else if (type == 'bookmaker') {
                    if (this.marketBookAndExposure && this.marketBookAndExposure.bookmakersBook && this.marketBookAndExposure.bookmakersBook.length) {
                        let marketBook = this.marketBookAndExposure.bookmakersBook.find(m => m.id == market.mi)?.runner_book;
                        if (!marketBook || marketBook.length == 3) {
                            return null
                        } else if(market.mn == 'TOSS') {

                            for (let i = 0; i < marketBook.length; i++) {

                                for (let j = 0; j < market.sl.length; j++) {
                                    if (marketBook[i].selection_id == market.sl[j].si) {
                                        marketBook[i] = {
                                            ...marketBook[i],
                                            back_odds: market.sl[j].ss !== 'ACTIVE' || market.sn !== 'ONLINE' ? 0 : (market.sl[j].b/100)+1,
                                            lay_odds: market.sl[j].l,
                                            si: market.sl[j].si,
                                            ss: market.sl[j].ss
                                        }
                                    }
                                }
                            }
                            let data = {
                                book : marketBook,
                                unavailableRunners : 0
                            }
                            return this.calculateCashoutStakeForBookmaker(data);
                            
                        } else {

                            let checkAllRunnerUnavailbableCount = 0;
                            for (let i = 0; i < marketBook.length; i++) {

                                for (let j = 0; j < market.sl.length; j++) {
                                    if (marketBook[i].selection_id == market.sl[j].si) {
                                        if(market.sl[j].ss !== 'ACTIVE' || market.sn !== 'ONLINE') { 
                                            checkAllRunnerUnavailbableCount += 1
                                        }   
                                        marketBook[i] = {
                                            ...marketBook[i],
                                            back_odds: market.sl[j].ss !== 'ACTIVE' || market.sn !== 'ONLINE' ? 0 : (market.sl[j].b/100)+1,
                                            lay_odds: market.sl[j].ss !== 'ACTIVE' || market.sn !== 'ONLINE' ? 0 : (market.sl[j].l/100)+1,
                                            si: market.sl[j].si,
                                            ss: market.sl[j].ss
                                        }
                                    }
                                }
                            }
                            let data = {
                                book : marketBook,
                                unavailableRunners : checkAllRunnerUnavailbableCount
                            }
                            return this.calculateCashoutStakeForBookmaker(data);
                        }
                    }
                }

            } catch (e) {
                console.log('=====', e)
            }
            let calculateBet = this.calculateCashoutStake(runners);
            return calculateBet;
        },
        getCashoutValue(market, type) {
            let betData = this.getBook(market, type);
            return this.chashOutRunnerBook(betData, type, market);
        },
        chashOutRunnerBook(betData, type, market) {
            if (betData && betData.length) {
                let finalBetStake = type == 'market' && market.marketName != 'Who Will Win The Match?' ? betData[0]?.finalStake : betData[0].cashoutStake?.run1 ? betData[0].cashoutStake?.run1 : betData[0]?.finalStake;
                if (finalBetStake >= 0) {
                    return '<div class="score-bottom"><span class="positive">&nbsp' + parseFloat(finalBetStake).toFixed(2) + '</span></div>';
                } else {
                    return '<span class="nagative-value">&nbsp' + ((-1) * parseFloat(finalBetStake).toFixed(2)) + '</span>';
                }
            }
        },
        cashoutServiceCall(market, type) {
            this.cashoutDetails.market = market;
            this.cashoutDetails.betOdd = this.cashoutMarketData?.[type == 'bookmaker' ? market.mi : market.mid]?.bet?.real_bet_odds;
            this.cashoutDetails.type = type;
            this.cashoutSlipCloseTime = setTimeout(() => {
                if(!this.CashoutLoader) {
                    this.$refs.closeCashoutModal.click();
                }
            }, 10000)
        },
        closeCashout() {
            this.cashoutDetails = {}; 
            clearTimeout(this.cashoutSlipCloseTime)
        },
        callforCashout() {
            let market = this.cashoutDetails.market;
            let type = this.cashoutDetails.type;
            let data = {
                match_id: this.eventDetails.matchId,
                bet_type: type,
                market_id: type == 'bookmaker' ? market.mi : market.mid,
                event_id: this.eventDetails.eventId,
                sport_id: this.eventDetails.sportId,
                validate: 0,
                betId : this.$dateTime.currentTimestamp(),
                userid: this.stateUser.userid,
                bet_delay: type == 'bookmaker' ? (market.bd || 0) : (market.bet_delay || 0),
                odds: this.cashoutDetails?.betOdd
            }
            this.CashoutLoader = true;
            this.$apiCall('post','BET_CASHOUT', data).then(response => {
                if (response.status == 200) {
                    try {
                        this.getEventExposures();
                        this.CashoutLoader = false;
                        this.$refs.closeCashoutModal.click();
                        this.$successToast(response.data.message)
                    } catch (e) {
                    }
                }
            }).catch(error => {
                this.CashoutLoader = false;
                this.$refs.closeCashoutModal.click();
                this.$errorToast(error[0])
            })
        },
        pageFilterApply() {
            this.$store.dispatch('seteventDetailHideSections', this.selectedPageSections);
            if ((this.eventDetailHideSections.includes('othermarkets_filters')) || this.selectedFancyTab == 'premiumFancy') {
                this.selectedFancyTab = 'Fancy'
            }
            this.$refs.eventDetailFilterModal.click();
            let data = { key:'fancy', title: 'Fancy', value: 'all', order: 1 };
            let openPremiunFancy = !this.fancyCategories?.some(item => item?.fancies && item?.fancies?.length)
            this.changeFancyCategory(data, openPremiunFancy)
        },
        showTv() {
            if (!this.$auth.status) {
                this.$errorToast('Please login first!');
                return
            }
            this.showLiveTv = !this.showLiveTv
        },
        // Low Balance
        toggleLowBalanceModal(){
            const modal = document.getElementById('LowBalanceModal');
            if(!modal.classList.contains('show')){
                this.$helper.openModal('#LowBalanceModal');
            }
        },
        getMarketDataByName(marketName = 'Main Market') {
			const marketData = this.getBetandAvgOdds.find(item => item.market === marketName);
			return marketData || {
				market: marketName,
				lay: { odds: 0, stake: 0, pl: 0, betCount: 0 },
				back: { odds: 0, stake: 0, pl: 0, betCount: 0 }
			};
		},
        getBetHeadingForSports(bet) {
           return `${bet.selection_type} ${bet.selection} For ${bet.stake} @ ${bet.odds} ${
                bet.selection_type === 'back' 
                    ? `To Win ${bet.pl}` 
                    : `Liability ${bet.liability}`
            }`
        },
    },
    beforeUnmount() {
        socketService.off('App\\\\Events\\\\SportsBroadcastData');
        socketService.off('App\\\\Events\\\\BroadcastBookmaker');
        socketService.off('App\\\\Events\\\\BroadcastFancy');
        socketService.emit("leave", [this.event_id]);
        if (this.intervalTimer) {
            clearInterval(this.intervalTimer);
        }
        this.$store.dispatch('seteventDetailHideSections', []);
    },
}
</script>

<style scoped>.open-bets-container {
    height: 75vh;
    overflow-y: auto;
}
.spinner-border {
    height: 20px;
    width: 20px;
}

.text-center#Otp_loader {
    height: 19px;
}

.guide-text{   
    color:#ff5252;
    caret-color: #ff5252;
    font-size: 14px;
    text-transform: capitalize;
}


@media screen and (max-width: 767px) {
    .details-inplay-game-sec {
        margin-bottom: 80px;
        display: inline-block;
        width: 100%;
    }
}

.disable-btn {
  cursor: not-allowed;
}
.fancy-lay.lay-text {
    margin: 0px 20px 0 15px;
}
.no-real-time {
    text-align: center;
    background: #f0ece1;
    margin-bottom: 10px;
    line-height: 4;
    color: #000000 !important;
}

.stake-input::placeholder {
  color: transparent !important; /* Hide when not focused */
}

.stake-input:focus::placeholder {
  color: #999 !important; /* Show with color when focused */
}
.match-win-title {
    text-wrap: nowrap;
}
</style>